export default {
  common_share: `공유하기`,
  common_share_short: `공유`,
  common_notice: `공지사항`,
  common_notification: `알림`,
  common_download: `다운로드`,
  common_download_plural: `다운로드`,
  common_update: `업데이트`,
  common_update_now: `지금 업데이트`,
  common_cancel: `취소`,
  common_close: `닫기`,
  common_ok: `확인`,
  common_confirm: `확인`,
  common_yes: `네`,
  common_no: `아니오`,
  common_save: `저장`,
  common_error_retry: `다시 시도`,
  common_login: `로그인`,
  common_logout: `로그아웃`,
  common_copy: `복사`,
  common_refresh: `새로고침`,
  common_delete: `삭제`,
  common_fix: `수정`,
  common_service_version: `서비스 버전`,
  common_edit: `편집`,
  common_language: `언어`,
  common_language_english: `English`,
  common_language_korean: `한국어`,
  common_language_zh_hant: `繁體中文`,
  common_language_thai: `ภาษาไทย`,
  common_language_indonesia: `Bahasa Indonesia`,
  common_language_french: `Français`,
  common_content_season: `시즌`,
  common_content_season_plural: `시즌`,
  common_content_episode: `회차`,
  common_content_episode_plural: `회차`,
  common_content_episode_value_short: `{{value}}화`,
  common_episode_count: `{{count}}개`,
  common_episode_count_plural: `{{count}}개`,
  common_content_favorite: `찜하기`,
  common_content_tag: `태그`,
  common_content_like: `좋아요`,
  common_content_like_plural: `좋아요`,
  common_universe: `유니버스`,
  common_universe_circle: `유니버스 서클`,
  common_viewer_alive: `ALIVE 뷰어`,
  common_matching_ai: `ai 매칭`,
  common_matching_special: `스페셜 매칭`,
  common_free: `무료`,
  common_paid: `유료`,
  common_rental: `대여`,
  common_gidamu: `기다무`,
  common_gidamu_plus: `{{value}}다무`,
  common_gidamu_plus_long: `{{value}}시간마다 무료`,
  common_ongoing_free: `연재무료`,
  common_free_available: `무료 열람 가능`,
  common_now_charging: `충전 중`,
  common_tab_library: `보관함`,
  common_tab_ranking: `랭킹`,
  common_tab_giftbox: `선물함`,
  common_tab_service_name: `KAKAO WEBTOON`,
  common_tab_time_table_global: `시간표`,
  common_tab_gidamu_plus: `기다무+`,
  common_cash: `캐시`,
  common_cash_amount: `{{value}}캐시`,
  common_cash_currency: `₩{{value}}`,
  common_cash_currency_symbol: `₩`,
  common_ticket_amount: `{{count}}장`,
  common_ticket_amount_plural: `{{count}}장`,
  common_cash_purchased: `구매 캐시`,
  common_cash_gift: `이벤트 캐시`,
  common_ticket: `이용권`,
  common_ticket_plural: `이용권`,
  common_ticket_possession: `소장권`,
  common_ticket_possession_plural: `소장권`,
  common_ticket_possession_amount: `소장권 {{count}}장`,
  common_ticket_possession_amount_plural: `소장권 {{count}}장`,
  common_ticket_rental: `대여권`,
  common_ticket_rental_plural: `대여권`,
  common_ticket_rental_amount: `대여권 {{count}}장`,
  common_ticket_rental_amount_plural: `대여권 {{count}}장`,
  common_ticket_gift: `선물 이용권`,
  common_ticket_gift_plural: `선물 이용권`,
  common_ticket_gift_amount: `선물 이용권 {{count}}장`,
  common_ticket_gift_amount_plural: `선물 이용권 {{count}}장`,
  common_ticket_gidamu: `기다무 이용권`,
  common_ticket_gidamu_plural: `기다무 이용권`,
  common_ticket_gidamu_amount: `기다무 이용권 {{count}}장`,
  common_ticket_gidamu_amount_plural: `기다무 이용권 {{count}}장`,
  common_expired: `기한 만료`,
  common_add: `충전`,
  common_purchase: `구매`,
  common_refund: `환불`,
  common_refund_past: `환불 완료`,
  common_use: `사용`,
  common_use_past: `사용 완료`,
  common_purchased: `소장`,
  common_crm_slot_ticket: `뽑기권`,
  common_crm_slot_ticket_plural: `뽑기권`,
  common_crm_reservation: `사전 예약`,
  common_bm_gidamu: `기다리면 무료`,
  common_bm_preview: `미리보기`,
  common_genre_all: `전체`,
  common_genre_romance: `로맨스`,
  common_genre_romance_fantasy: `로맨스 판타지`,
  common_genre_comedy: `코믹,일상`,
  common_genre_action_fantasy: `학원,판타지`,
  common_genre_drama_fantasy: `판타지 드라마`,
  common_genre_action: `액션,무협`,
  common_genre_fantasy: `판타지`,
  common_genre_thriller_horror: `공포,스릴러`,
  common_genre_bl: `BL,GL`,
  common_genre_drama: `드라마`,
  common_schedule_daily: `Daily`,
  common_schedule_new: `신작`,
  common_schedule_mon: `월`,
  common_schedule_tue: `화`,
  common_schedule_wed: `수`,
  common_schedule_thu: `목`,
  common_schedule_fri: `금`,
  common_schedule_sat: `토`,
  common_schedule_sun: `일`,
  common_schedule_completed: `완결`,
  common_time_year_ago: `{{count}}년 전`,
  common_time_year_ago_plural: `{{count}}년 전`,
  common_time_month_ago: `{{count}}달 전`,
  common_time_month_ago_plural: `{{count}}달 전`,
  common_time_day_ago: `{{count}}일 전`,
  common_time_day_ago_plural: `{{count}}일 전`,
  common_time_hour_ago: `{{count}}시간 전`,
  common_time_hour_ago_plural: `{{count}}시간 전`,
  common_time_minute_ago: `{{count}}분 전`,
  common_time_minute_ago_plural: `{{count}}분 전`,
  common_time_second_ago: `방금`,
  common_now: `지금`,
  common_period_year: `{{count}}년`,
  common_period_year_plural: `{{count}}년`,
  common_period_month: `{{count}}월`,
  common_period_month_plural: `{{count}}월`,
  common_period_day: `{{count}}일`,
  common_period_day_plural: `{{count}}일`,
  common_period_hour: `{{count}}시간`,
  common_period_hour_plural: `{{count}}시간`,
  common_period_minute: `{{count}}분`,
  common_period_minute_plural: `{{count}}분`,
  common_period_year_short: `{{count}}년`,
  common_period_year_short_plural: `{{count}}년`,
  common_period_month_short: `{{count}}월`,
  common_period_month_short_plural: `{{count}}월`,
  common_period_day_short: `{{count}}일`,
  common_period_day_short_plural: `{{count}}일`,
  common_period_hour_short: `{{count}}시간`,
  common_period_hour_short_plural: `{{count}}시간`,
  common_period_minute_short: `{{count}}분`,
  common_period_minute_short_plural: `{{count}}분`,
  common_period_second_short: `{{count}}초`,
  common_period_second_short_plural: `{{count}}초`,
  common_time_left: `{{value}} 남음`,
  common_time_ago: `{{value}} 전`,
  common_stroage_kb: `{{value}} KB`,
  common_stroage_mb: `{{value}} MB`,
  common_stroage_gb: `{{value}} GB`,
  common_service_name: `카카오웹툰 - KAKAO WEBTOON`,
  common_not_select: `설정 안함`,
  common_kakaowebtoon: `카카오웹툰`,
  common_tab_home: `홈`,
  recomm_tab_recommendations: `추천`,
  recomm_tab_special: `스페셜`,
  recomm_tab_gidamu: `3다무`,
  recomm_top_100: `TOP 100`,
  recomm_tab_gidamu_description: `{{hour}}시간마다 <grey-bold>기다무 이용권</grey-bold>이 생겨요! 인기 웹툰 지금 달려보세요.`,
  recomm_label_gidamu: `{{value}}시간마다 무료`,
  top_guide_popup: `기다리면 무료 알림
여기서 확인하세요.`,
  recomm_label_popular: `인기`,
  recomm_label_completed_nearly: `완결 임박`,
  recomm_label_completed_nearly_detail: `완결 예정`,
  recomm_label_upcoming: `업커밍`,
  recomm_label_trailer: `영화 예고편`,
  recomm_label_original_movie: `영화 원작`,
  recomm_label_original_drama: `드라마 원작`,
  recomm_label_event: `이벤트`,
  recomm_label_event_detail_gift: `캐시 선물`,
  recomm_label_event_detail_max: `최대 지급`,
  recomm_label_ticket_detail: `{{value}}장`,
  recomm_label_ticket_detail_v4: `{{value}}장 지급`,
  recomm_label_ticket_detail_gift: `이용권 선물`,
  recomm_label_legend: `레전드`,
  recomm_label_new_detail: `조회수`,
  recomm_label_popular_detail: `누적 조회수`,
  recomm_label_recommendation: `AI 추천`,
  common_tab_top: `TOP`,
  common_tab_hot: `지금 핫한`,
  common_tab_free_today: `오늘 연재무료`,
  ranking_tab_weekly: `주간`,
  ranking_tab_daily: `일간`,
  ranking_tab_real_time: `실시간`,
  ranking_in_progress: `랭킹 집계 중입니다.`,
  ranking_badge_new: `NEW`,
  ranking_criteria_popup_title: `랭킹 집계 기준`,
  ranking_criteria_popup_contents: `카카오웹툰에서 제공하는 모든 랭킹은 시간 단위로 집계되며, 지난 한 시간 동안의 열람 및 구매 등 사용자 반응을 기반으로 순위가 매겨집니다.`,
  common_tab_category: `디스커버`,
  category_tab_ranking: `랭킹`,
  category_tab_ranking_weekly: `주간`,
  category_tab_ranking_daily: `일간`,
  category_tab_ranking_real_time: `실시간`,
  category_tab_ranking_in_progress: `랭킹 집계 중입니다.`,
  category_tab_ranking_badge_new: `NEW`,
  category_tab_new: `신작`,
  category_tab_ongoing: `연재중`,
  category_tab_completed: `완결`,
  common_tab_original_webtoon: `웹툰원작`,
  common_tab_original_novel: `소설원작`,
  schedule_new_today: `오늘`,
  schedule_genre_filter_all: `전체`,
  schedule_monday: `월요일`,
  schedule_tuesday: `화요일`,
  schedule_wednesday: `수요일`,
  schedule_thursday: `목요일`,
  schedule_friday: `금요일`,
  schedule_saturday: `토요일`,
  schedule_sunday: `일요일`,
  schedule_empty: `등록된 작품이 없습니다.`,
  schedule_completed_label_legend: `레전드`,
  schedule_completed_label_pd: `PD추천`,
  schedule_completed_label_trailer: `영화 예고편`,
  schedule_completed_label_recommendation: `추천`,
  schedule_completed_label_magazine: `매거진`,
  schedule_completed_label_cashback: `캐시백`,
  schedule_two_column: `2단 보기`,
  schedule_three_column: `3단 보기`,
  schedule_four_column: `4단 보기`,
  schedule_two_column_selected: `2단으로 봅니다.`,
  schedule_three_column_selected: `3단으로 봅니다. `,
  schedule_four_column_selected: `4단으로 봅니다.`,
  schedule_sort_guide: `요일별로 연재 중인 작품을 모았어요. 
원하는 순서로 목록을 정렬해 보세요. `,
  schedule_guide_popup: `목록의 순서와 타입을 변경할 수 있어요.`,
  schedule_sort_title: `정렬 선택`,
  schedule_sort_recommend: `추천순`,
  schedule_sort_early_access: `연재무료 우선순`,
  schedule_sort_gidamu: `기다리면 무료 우선순`,
  schedule_sort_gidamu_short: `기다리면 무료 시간 짧은 순`,
  schedule_sort_not_provided_toast: `현재 추천순 정렬만 가능합니다.`,
  schedule_genre_select_popup: `장르 선택`,
  login_action_view_next_episode_popup: `다음 회차를 보시려면
로그인을 해주세요. `,
  contenthome_wifi_popup: `Wi-Fi 에 연결되어 있지 않습니다. 
모바일 데이터를 사용하시겠어요?`,
  contenthome_ticketused_possession_snackbar: `소장권 {{value}}장을 사용했습니다.`,
  contenthome_ticketused_rental_snackbar: `대여권 {{value}}장을 사용했습니다.`,
  contenthome_ticketused_gift_snackbar: `선물 이용권 {{value}}장을 사용했습니다.`,
  contenthome_ticketused_gidamu_snackbar: `기다무 이용권 {{value}}장을 사용했습니다.`,
  contenthome_ticket_option_popup: `어떤 이용권을 쓰시겠어요?`,
  contenthome_popup_rent_button: `대여권`,
  contenthome_popup_possess_button: `소장권`,
  contenthome_ticket_remaining: `대여권: {{rental}}장 / 소장권: {{possess}}장`,
  contenthome_ticket_remaining_rental_plural: `대여권: {{rental}}장 / 소장권: {{possess}}장`,
  contenthome_ticket_remaining_possession_plural: `대여권: {{rental}}장 / 소장권: {{possess}}장`,
  contenthome_ticket_remaining_plural: `대여권: {{rental}}장 / 소장권: {{possess}}장`,
  contenthome_popup_ticket_rental: `대여권: {{count}}장`,
  contenthome_popup_ticket_rental_plural: `대여권: {{count}}장`,
  contenthome_popup_ticket_possession: `소장권: {{count}}장`,
  contenthome_popup_ticket_possession_plural: `소장권: {{count}}장`,
  contenthome_latest_ep_ticket_popup: `최신 {{value}}회차는 기다무 이용권을
사용할 수 없는 회차입니다.
다른 이용권을 사용하시겠습니까?`,
  contenthome_latest_ep_ticket_rental_popup: `최신 {{value}}회차는 기다무 이용권을
사용할 수 없는 회차입니다.
대여권이 사용됩니다.`,
  contenthome_latest_ep_ticket_possession_popup: `최신 {{value}}회차는 기다무 이용권을
사용할 수 없는 회차입니다.
소장권이 사용됩니다.`,
  contenthome_not_gidamu_ep_ticket_popup: `기다무 이용권을 사용할 수 없는 회차입니다.
다른 이용권을 사용하시겠습니까? `,
  contenthome_not_gidamu_ep_ticket_rental_popup: `기다무 이용권을 사용할 수 없는 회차입니다.
대여권이 사용됩니다.`,
  contenthome_not_gidamu_ep_ticket_possession_popup: `기다무 이용권을 사용할 수 없는 회차입니다.
소장권이 사용됩니다.`,
  contenthome_rented_ep_ticket_rental_popup: `대여한 적이 있는 회차입니다.
대여권으로 다시 감상하시겠어요?`,
  contenthome_rented_ep_ticket_possession_popup: `대여한 적이 있는 회차입니다.
소장권으로 다시 감상하시겠어요?`,
  contenthome_rented_ep_ticket_gift_popup: `대여한 적이 있는 회차입니다.
선물 이용권으로 다시 감상하시겠어요?`,
  contenthome_rented_ep_ticket_gidamu_popup: `대여한 적이 있는 회차입니다.
기다무 이용권으로 다시 감상하시겠어요?`,
  contenthome_rented_ep_ticket_popup: `대여한 적이 있는 회차입니다.
다시 감상하시겠어요?`,
  contenthome_rented_ep_purchase_ticket_popup: `대여한 적이 있는 회차입니다.
이용권을 구매하시겠어요?`,
  contenthome_expired_popup: `대여 기간이 만료되었습니다. 
이어 볼 회차를 선택해 주세요.`,
  contenthome_expired_popup_viewed_button: `보던 회차`,
  contenthome_expired_popup_next_button: `다음 회차`,
  contenthome_latest_expired_ticket_rental_popup: `대여 이력이 있는 최신 {{value}}회차로
기다무 이용권을 사용할 수 없습니다.
대여권이 사용됩니다.`,
  contenthome_latest_expired_ticket_possession_popup: `대여 이력이 있는 최신 {{value}}회차로
기다무 이용권을 사용할 수 없습니다.
소장권이 사용됩니다.`,
  contenthome_latest_expired_ticket_popup: `대여 이력이 있는 최신 {{value}}회차로
기다무 이용권을 사용할 수 없습니다.
다른 이용권을 사용하시겠습니까? `,
  contenthome_stop_sell_popup: `판매 중지된 회차로 감상할 수 없습니다. `,
  contenthome_ticketused_gift_popup: `선물 이용권을 쓰시겠어요?`,
  contenthome_ticketused_rental_popup: `대여권을 쓰시겠어요?`,
  contenthome_ticketused_possession_popup: `소장권을 쓰시겠어요?`,
  contenthome_ticketused_gidamu_popup: `기다무 이용권을 쓰시겠어요?`,
  contenthome_latest_ep_gidamu_popup: `기다무 이용권으로 감상할 수 없는 회차`,
  contenthome_universe_matching: `{{title}} 외 {{matching}}`,
  contenthome_universe_similar_title: `작품과 비슷한 작품들`,
  contenthome_universe_similar_drawing: `작품과 비슷한 그림체 작품들`,
  contenthome_universe_same_genre: `작품과 같은 {{genre}} 작품들`,
  contenthome_universe_today_popular: `오늘 사람들이 가장 많이 본 작품들`,
  contenthome_universe_today_favorite: `오늘 사람들이 가장 많이 찜한 작품들 `,
  contenthome_gift_rental_popup: `선물 이용권 {{count}}장을 받았습니다.`,
  contenthome_gift_rental_popup_plural: `선물 이용권 {{count}}장을 받았습니다.`,
  contenthome_gift_rental_valid_until_popup: `유효기간: 지급일로부터 3일 `,
  contenthome_expiry_specific_date: `유효기간: {{value}}`,
  contenthome_fav_notification_popup_title: `보관함 > 찜한 작품에 추가되었습니다.`,
  contenthome_fav_notification_popup_content: `작품 업데이트 시 알림을 받습니다. `,
  contenthome_fav_undo_toast: `보관함 > 찜한 작품에서 삭제되었습니다.`,
  contenthome_ticketbar_ticket: `이용권 {{count}}장 `,
  contenthome_ticketbar_ticket_plural: `이용권 {{count}}장 `,
  contenthome_ticketbar_newbie_ticket: `신규 혜택 이용권 {{count}}장`,
  contenthome_ticketbar_newbie_ticket_plural: `신규 혜택 이용권 {{count}}장`,
  contenthome_ticketbar_gidamu: `{{count}}일마다 무료`,
  contenthome_ticketbar_gidamu_plural: `{{count}}일마다 무료`,
  contenthome_ticketbar_gidamu_hour: `{{count}}시간마다 무료`,
  contenthome_ticketbar_gidamu_hour_plural: `{{count}}시간마다 무료`,
  contenthome_ticketbar_gidamu_minute: `{{count}}분마다 무료`,
  contenthome_ticketbar_gidamu_minute_plural: `{{count}}분마다 무료`,
  contenthome_ticketbar_gidamu_full: `기다무 충전 완료`,
  contenthome_ticketbar_ep_free: `{{count}}편 무료`,
  contenthome_ticketbar_ep_free_plural: `{{count}}편 무료`,
  contenthome_ticketbar_all_free: `완전무료`,
  contenthome_ticketbar_charged: `1장 충전 완료`,
  contenthome_ticketbar_charging: `{{value}} 후 충전`,
  contenthome_ticketbar_preview: `미리보기 {{count}}개`,
  contenthome_ticketbar_preview_plural: `미리보기 {{count}}개`,
  contenthome_ticketbar_unavailable: `판매 중지`,
  contenthome_guide_popup: `화면을 오른쪽으로 넘기면 매칭 작품을,
화면 아래로 당기면
매칭 그룹을 볼 수 있습니다. `,
  contenthome_total: `전체`,
  contenthome_first_episode_tab_button: `첫 화 보기`,
  contenthome_first_episode_tab_continue: `첫 화 이어보기`,
  contenthome_first_episode_tab_guide: `내가 볼 회차를
바로 확인하세요.`,
  contenthome_first_episode_tab_content: `다음 이야기가 궁금하다면?`,
  contenthome_first_episode_tab_page_only: `가로로 보는 작품입니다.  
전용 뷰어에서 보시겠어요?`,
  contenthome_first_episode_tab_paid: `유료 회차입니다. 
이용권으로 감상하시겠어요?`,
  contenthome_first_episode_tab_stop_sell: `판매 중지된 작품입니다.`,
  contenthome_first_episode_tab_related_novel: `이 웹툰의 관련 소설`,
  contenthome_first_episode_tab_viewer: `뷰어로 보기`,
  contenthome_continue_episode_tab_last_read: `{{value}}
감상한 회차입니다.`,
  contenthome_continue_episode_tab_last_episode: `다음 회차가 없습니다.`,
  contenthome_continue_episode_tab_stop_sell: `판매 중지된 회차입니다.`,
  contenthome_continue_next_episode: `다음 회차 {{value}}`,
  contenthome_continue_last_episode: `다음 회차가 없습니다. `,
  contenthome_episode_tab_button: `회차`,
  contenthome_preview_day: `{{count}}일 후 무료`,
  contenthome_preview_day_plural: `{{count}}일 후 무료`,
  contenthome_ep_tab_order_latest_snackbar: `최신화부터 봅니다.`,
  contenthome_ep_tab_order_chronological_snackbar: `첫 화부터 봅니다.`,
  contenthome_ep_tab_first_episode_button: `첫 화 보기`,
  contenthome_ep_tab_continue_episode_button: `{{value}} 이어보기`,
  contenthome_ep_tab_continue_without_episode_button: `이어보기`,
  contenthome_ep_tab_back_top_button: `맨 위로`,
  contenthome_alive_unzipping: `파일 처리 중… `,
  contenthome_alive_download_popup_title: `ALIVE는 새로운 방식의 웹툰 뷰어입니다.
사운드와 함께 감상하세요. `,
  contenthome_storage_full_popup_title: `기기 저장 공간이 부족합니다. `,
  contenthome_storage_full_popup_content: `저장 공간 확인 후 다시 시도해 주세요. `,
  contenthome_alive_fail_unzip_popup_title: `파일 압축 풀기에 실패했습니다.`,
  contenthome_alive_fail_unzip_popup_content: `파일을 다시 다운로드 받으세요.`,
  contenthome_ep_tab_stop_sell_popup: `판매 금지된 회차로 감상할 수 없습니다. `,
  contenthome_ep_expired: `대여 기간 만료`,
  contenthome_ep_tab_type_thumbnail: `섬네일 뷰`,
  contenthome_ep_tab_type_list: `리스트 뷰`,
  contenthome_ep_tab_order_latest: `최신순`,
  contenthome_ep_tab_order_chronological: `등록순`,
  contenthome_ep_tab_type_thumbnail_toast: `섬네일로 봅니다.`,
  contenthome_ep_tab_type_list_toast: `리스트로 봅니다.`,
  contenthome_ep_tab_download_guide_popup: `리스트 타입에서 회차 다운로드를 받을 수 있습니다. `,
  contenthome_ep_tab_type_popup_title: `다운로드와 열람을 함께 사용할 수 있는\n리스트 타입을 제공합니다.`,
  contenthome_info_tab_button: `정보`,
  contenthome_info_tab_author: `글`,
  contenthome_info_tab_illustrator: `그림`,
  contenthome_info_tab_original: `원작`,
  contenthome_info_tab_adaptation: `각색`,
  contenthome_info_tab_color: `컬러`,
  contenthome_info_tab_publisher: `발행처`,
  contenthome_info_tab_summary: `줄거리`,
  contenthome_info_tab_more_button: `더 보기`,
  contenthome_info_tab_keywords: `키워드`,
  contenthome_info_tab_video: `영상`,
  contenthome_info_tab_video_v4: `관련 영상`,
  contenthome_info_tab_teaser: `티저 영상`,
  contenthome_info_tab_special: `스페셜 콘텐츠`,
  contenthome_info_tab_rec_author: `{{author}} 작가의 다른 작품`,
  viewer_end_recommendation: `이 작품과 유사한 작품`,
  contenthome_ticket_tab_button: `이용권`,
  contenthome_ticket_tab_gift_ticket_1: `EVENT`,
  contenthome_ticket_tab_gift_ticket_2: `선물 이용권 {{value}}장`,
  contenthome_ticket_tab_gift_ticket_button: `받기`,
  contenthome_ticket_tab_gift_ticket_remaining: `보유 이용권`,
  contenthome_ticket_tab_ticket_purchase_button: `구매`,
  contenthome_ticket_tab_ticket_history: `이용권 내역`,
  contenthome_ticket_tab_ticket_count: `{{count}}장`,
  contenthome_ticket_tab_ticket_count_plural: `{{count}}장`,
  contenthome_comment_tab_button: `댓글`,
  comment_order_recent_snackbar: `최신순으로 봅니다.`,
  comment_order_likes_snackbar: `인기순으로 봅니다.`,
  comment_order_recent: `최신순`,
  comment_order_likes: `인기순`,
  contenthome_comment_empty: `등록된 댓글이 없습니다.`,
  contenthome_tickethistory: `작품 이용권 내역`,
  contenthome_sidemenu_notice: `작품 공지사항`,
  contenthome_sidemenu_clearhistory: `감상 이력 전체 삭제`,
  contenthome_sidemenu_share: `작품 공유`,
  share_popup_title: `공유하기`,
  share_link_copied_paste_toast: `주소를 복사했습니다. 
원하는 곳에 붙여넣기 해주세요. `,
  contenthome_sidemenu_download_autodelete: `보관함 > 다운로드 에서 관리할 수 있습니다.`,
  contenthome_sidemenu_download_available: `다운로드 가능  `,
  contenthome_sidemenu_download_waiting: `다운로드 대기`,
  contenthome_sidemenu_download_complete: `다운로드 완료 `,
  contenthome_sidemenu_download_purchase: `구매 후 다운로드`,
  contenthome_sidemenu_download_fail: `다운로드 실패`,
  contenthome_sidemenu_register_popup_title: `현재 기기를 등록하시겠어요?`,
  contenthome_sidemenu_register_popup_content: `현재 기기를 등록해야 다운로드 할 수 있습니다. 
ID 당 2개의 기기를 등록할 수 있으며, 월 1회 변경 가능합니다. `,
  settings_device_register_impossible_exceed_popup_title: `기기 등록 변경 횟수가 초과되어\n등록할 수 없습니다.`,
  settings_device_register_impossible_exceed_popup_content: `기기 등록 변경은 월 1회만 가능합니다. `,
  settings_device_register_exceed_popup: `등록 가능한 기기 수가 초과되었습니다.\n이미 등록된 기기 중 하나를 해제하신 뒤\n신규 등록할 수 있습니다.`,
  settings_device: `기기 등록 관리`,
  contenthome_sidemenu_download_data_popup_title: `다운로드를 위해 모바일 데이터를 사용하시겠습니까? `,
  contenthome_sidemenu_download_data_popup_content: `Wi-Fi 에 연결되어 있지 않습니다. 
데이터 요금이 부과될 수 있습니다. `,
  contenthome_sidemenu_download_complete_popup_title: `{{title}} 다운로드 완료`,
  contenthome_sidemenu_download_complete_popup_content: `{{episode}} 다운로드를 완료했습니다.`,
  contenthome_sidemenu_download_complete_popup_content_plural: `{{count}}개 회차의 다운로드를 완료했습니다.`,
  contenthome_sidemenu_download_fail_popup_title: `{{title}} 다운로드 실패`,
  contenthome_sidemenu_download_fail_popup_content: `{{episode}} 다운로드에 실패했습니다.`,
  contenthome_sidemenu_download_fail_popup_content_plural: `{{count}}개 회차의 다운로드에 실패했습니다.`,
  notification_notice_list_blank: `등록된 공지사항이 없습니다.`,
  contenthome_sidemenu_clearhistory_deleted: `감상 이력을 삭제했습니다.`,
  contenthome_universe_matching_exploring: `탐색 중`,
  contenthome_universe_matching_type_ai: `AI 매칭`,
  contenthome_universe_title: `{{title}} 작품 외`,
  contenthome_universe_matching_type_ai_similar: `{{title}} 작품과
비슷한 작품들`,
  contenthome_universe_matching_type_ai_drawing: `{{title}} 작품과
비슷한 그림체의 작품들`,
  contenthome_universe_matching_type_ai_genre: `{{title}} 작품과
같은 {{genre}} 작품들`,
  contenthome_universe_matching_type_special: `스페셜 매칭`,
  contenthome_universe_matching_type_special_other: `{{title}} 외
{{matching}}`,
  contenthome_universe_matching_type_today: `오늘의 매칭`,
  contenthome_universe_matching_type_today_mostviewed: `오늘 사람들이
가장 많이 본 작품들`,
  contenthome_universe_matching_type_today_mostpopular: `오늘 사람들이
가장 많이 찜한 작품들`,
  contenthome_universe_matching_type_nextup: `다음으로 볼 {{type}}`,
  contenthome_universe_matching_blank: `매칭된 유니버스가 없습니다. `,
  contenthome_universe_matching_first: `첫번째 작품입니다.`,
  contenthome_universe_matching_last: `마지막 작품입니다.`,
  contenthome_stop_sell_refund_popup: `판매 중지된 작품입니다.
남은 이용권을 환불하시겠어요?`,
  contenthome_stop_sell_toast: `판매 중지된 작품입니다. `,
  contenthome_prohibited_sell_popup: `판매 금지된 작품으로 감상할 수 없습니다.`,
  contenthome_tickethistory_purchased: `충전 내역`,
  contenthome_tickethistory_used: `사용 내역`,
  contenthome_tickethistory_gidamu_minute: `{{count}}분마다 1장 무료`,
  contenthome_tickethistory_gidamu_minute_plural: `{{count}}분마다 1장 무료`,
  contenthome_tickethistory_gidamu_day: `{{count}}일마다 1장 무료`,
  contenthome_tickethistory_gidamu_day_plural: `{{count}}일마다 1장 무료`,
  contenthome_tickethistory_gidamu_hour: `{{count}}시간마다 1장 무료`,
  contenthome_tickethistory_gidamu_hour_plural: `{{count}}시간마다 1장 무료`,
  contenthome_tickethistory_popup_detail_minute_1: `'기다리면 무료' 이용권 사용 후 {{count}}분 기다리시면 다시 이용권 1장을 드립니다. `,
  contenthome_tickethistory_popup_detail_minute_1_plural: `'기다리면 무료' 이용권 사용 후 {{count}}분 기다리시면 다시 이용권 1장을 드립니다. `,
  contenthome_tickethistory_popup_detail_hour_1: `'기다리면 무료' 이용권 사용 후 {{count}}시간 기다리시면 다시 이용권 1장을 드립니다. `,
  contenthome_tickethistory_popup_detail_hour_1_plural: `'기다리면 무료' 이용권 사용 후 {{count}}시간 기다리시면 다시 이용권 1장을 드립니다. `,
  contenthome_tickethistory_popup_detail_day_1: `'기다리면 무료' 이용권 사용 후 {{count}}일 기다리시면 다시 이용권 1장을 드립니다. `,
  contenthome_tickethistory_popup_detail_day_1_plural: `'기다리면 무료' 이용권 사용 후 {{count}}일 기다리시면 다시 이용권 1장을 드립니다. `,
  contenthome_tickethistory_popup_detail_2: `최신 {{value}}회차는 기다무 이용권으로 감상할 수 없습니다.`,
  contenthome_tickethistory_popup_detail_3: `대여권으로 3일동안 감상할 수 있습니다.`,
  contenthome_tickethistory_gift_event: `이벤트 선물`,
  ticket_history_used_newbie: `신규 혜택`,
  contenthome_tickethistory_cancelled: `취소 완료`,
  contenthome_tickethistory_refund_title: `이용권 구매 취소`,
  contenthome_tickethistory_refund_purchase_info: `구매 정보`,
  contenthome_tickethistory_refund_purchase_info_date: `구매 날짜`,
  contenthome_tickethistory_refund_purchase_info_number: `구매 번호`,
  contenthome_tickethistory_refund_purchase_info_ticket: `구매 이용권 수`,
  contenthome_tickethistory_refund_purchase_info_ticket_plural: `구매 이용권 수`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus: `{{count}}장 + {{bonus}}장 보너스`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus_plural: `{{count}}장 + {{bonus}}장 보너스`,
  contenthome_tickethistory_refund_info: `환불 정보`,
  contenthome_tickethistory_refund_info_ticket: `취소 가능 이용권 수`,
  contenthome_tickethistory_refund_info_ticket_cash: `이용권 1장당 캐시`,
  contenthome_tickethistory_refund_info_cash: `환불 캐시`,
  contenthome_tickethistory_refund_info_cash_expired: `만료된 이벤트 캐시`,
  contenthome_tickethistory_refund_info_cash_able: `환불 가능 캐시`,
  contenthome_tickethistory_refund_notice_price: `환불 금액에 대한 안내 `,
  contenthome_tickethistory_refund_notice_price_1: `유효기간이 지난 이벤트 캐시는 환불 금액에 포함되지 않습니다.`,
  contenthome_tickethistory_refund_notice_price_2: `유효기간이 지난 이벤트 캐시 정보로 인하여 실제 구매 취소 금액과 이용권 내역, 캐시 내역의 정보가 다를 수 있습니다. `,
  contenthome_tickethistory_refund_notice_policy: `환불 정책에 대한 안내 `,
  contenthome_tickethistory_refund_notice_policy_1: `이벤트 캐시로 구매한 이용권은 이벤트 캐시 유효기간 내에만 환불 가능합니다.`,
  contenthome_tickethistory_refund_notice_policy_2: `‘오늘의 이용권 선물’ , ‘신규 열람 혜택 이용권’, ‘패키지 보너스 이용권’ 등 무료로 지급된 이용권은 구매 취소 대상이 아닙니다. `,
  contenthome_tickethistory_refund_notice_policy_3: `이용권은 카카오웹툰 캐시로만 환불 가능합니다.`,
  contenthome_tickethistory_refund_notice_policy_4: `이용권 구매 취소는 되돌릴 수 없으니 신중하게 진행해 주세요.`,
  contenthome_tickethistory_refund_notice_policy_5: `캐시 환불 문의는 고객센터를 이용해 주세요.`,
  contenthome_tickethistory_refund_button: `이용권 구매 취소하기`,
  contenthome_tickethistory_refund_popup: `이용권 구매를 취소하시겠어요?`,
  contenthome_tickethistory_refund_detail_popup: `취소 이용권: {{ticket}}장 / 환불 캐시: {{cash}}`,
  contenthome_tickethistory_refund_detail_popup_plural: `취소 이용권: {{ticket}}장 / 환불 캐시: {{cash}}`,
  contenthome_tickethistory_refund_snackbar: `이용권 구매가 취소되었습니다.`,
  contenthome_tickethistory_used_gift_event: `선물 이용권 (이벤트 선물) `,
  contenthome_tickethistory_used_gift_newbie: `선물 이용권 (신규 혜택) `,
  gift_ticket_fail_received_popup: `이미 받은 선물입니다.`,
  gift_ticket_fail_expired_popup: `선물 받을 수 있는 기간이 지났습니다.`,
  viewer_capture_aos_snackbar: `보안 정책에 따라 화면을 캡쳐할 수 없습니다.`,
  viewer_capture_ios_popup_title: `저작권 법적 고지`,
  viewer_capture_ios_popup_content: `작품 스크린샷을 무단으로 공유,배포할 경우 법적 처벌을 받을 수 있습니다. 캡쳐 이력은 시스템에 의해 추적이 가능하며, 유포한 사실이 확인될 경우 법적 처벌의 대상이 됩니다. `,
  viewer_record_snackbar: `보안 정책에 따라 화면을 기록할 수 없습니다.`,
  viewer_stop_sale_popup: `판매 중지된 회차로 감상할 수 없습니다. `,
  viewer_related_novel: `이 웹툰의 관련 소설`,
  contenthome_alive_download_popup_content: `다운로드 후 감상할 수 있습니다. 
Wi-Fi 연결을 권장합니다.`,
  viewer_marathon_viewing_snackbar: `정주행 모드로 전환합니다. 
필요한 경우 보유하신 이용권을 자동으로 씁니다.`,
  viewer_marathon_viewing_last_ep_toast: `다음화가 없습니다.`,
  viewer_marathon_viewing_first_ep_toast: `이전화가 없습니다.`,
  viewer_marathon_viewing_guide_app: `정주행 모드는 회차 이동 없이 스크롤만으로
끊임없이 감상할 수 있는 기능입니다.`,
  viewer_end_gidamu_plus_info: `‘{{contentname}}’작품은\n{{value}}시간마다 무료로 볼 수 있어요! `,
  viewer_end_like_first: `처음 좋아요를 눌러보세요.`,
  viewer_end_like_snackbar: `이 작품을 정말 좋아하시네요!
좋아요는 회차 당 5번까지 가능합니다.`,
  viewer_end_comment_count: `댓글 {{value}}개 보기 `,
  viewer_end_comment_count_zero: `댓글 0개`,
  viewer_end_comment_count_v4: `댓글 {{value}}개`,
  viewer_end_comment_button: `댓글 보기`,
  viewer_end_next_button: `다음 회차 <white>{{value}}</white> 보기`,
  viewer_end_next_button_v4: `다음 회차 {{value}}`,
  viewer_end_last_episode: `다음 회차가 없습니다. `,
  viewer_end_next_pull: `당겨서 <grey>{{value}}</grey> 보기`,
  viewer_end_recommendation_v4: `이 작품과 비슷한 작품`,
  viewer_ep_list_free: `무료`,
  viewer_ep_list_gidamu: `기다무`,
  viewer_ep_list_rent: `대여`,
  viewer_ep_list_possess: `소장`,
  viewer_top_button: `맨 위로`,
  viewer_page_swipe_snackbar: `왼쪽으로 넘기세요.`,
  viewer_page_swipe_right_snackbar: `오른쪽으로 넘기세요.`,
  viewer_setting_zoom_button: `확대 / 축소`,
  viewer_setting_preview_comment_button: `댓글 미리보기`,
  viewer_setting_remember_button: `보던 위치 기억`,
  viewer_setting_autoscroll_button: `자동 스크롤`,
  viewer_setting_autoscroll_button_v4: `자동 스크롤 속도`,
  viewer_setting_autoscroll_toast: `자동 스크롤 모드로 전환합니다.\n 스크롤 속도는 설정에서 변경할 수 있습니다.`,
  viewer_setting_bgm_button: `BGM`,
  viewer_setting_brightness: `화면 밝기`,
  viewer_setting_share_ep_button: `회차 공유`,
  viewer_setting_capture_screen_button: `장면 캡쳐`,
  viewer_setting_view_page_button: `가로 보기`,
  viewer_setting_view_scroll_button: `세로 보기`,
  viewer_setting_capture_button: `캡쳐하기`,
  viewer_setting_capture_saved: `내 사진첩에 저장되었습니다.`,
  viewer_setting_capture_access_required_popup: `캡쳐 화면을 저장하기 위해 권한이 필요합니다.`,
  viewer_setting_capture_access_authorization_required: `캡쳐 화면을 저장하기 위해 
사진 접근 권한을 허용해 주세요. `,
  viewer_setting_hide_comment_off: `댓글 숨김 끔`,
  viewer_setting_hide_comment_on: `댓글 숨김 켬 `,
  viewer_setting_enlarge_off: `확대 보기 끔`,
  viewer_setting_enlarge_on: `확대 보기 켬`,
  viewer_setting_last_viewed_off: `보던 위치 기억하기 끔`,
  viewer_setting_last_viewed_on: `보던 위치 기억하기 켬`,
  viewer_setting_sound_off: `소리 끔`,
  viewer_setting_sound_on: `소리 켬`,
  viewer_setting_view_page: `가로 보기`,
  viewer_setting_view_scroll: `세로 보기`,
  viewer_setting_view_page_switch_toast: `가로로 봅니다.`,
  viewer_setting_view_scroll_switch_toast: `세로로 봅니다.`,
  viewer_setting_enlarge_on_text: `더블탭으로 확대/축소`,
  viewer_setting_enlarge_off_text: `확대/축소 안 함`,
  viewer_setting_preview_comment_on_text: `뷰어 하단 댓글 미리보기`,
  viewer_setting_preview_comment_off_text: `뷰어 하단 댓글 제거`,
  viewer_setting_last_viewed_on_text: `보던 위치로 이동`,
  viewer_setting_last_viewed_off_text: `보던 위치 기억 안 함`,
  viewer_setting_autoscroll_on_text: `롱탭으로 자동 스크롤`,
  viewer_setting_autoscroll_off_text: `자동스크롤 안 함`,
  viewer_setting_sound_on_text: `배경 음악 켬`,
  viewer_setting_sound_off_text: `배경 음악 끔`,
  viewer_onetouch_popup_title: `이용권이 필요 합니다.`,
  viewer_onetouch_popup_title_1_web: `{{value}} 이용권이`,
  viewer_onetouch_popup_title_2_web: ` 필요합니다.`,
  viewer_onetouch_popup_title_ticket: `대여하고 바로 이어보시겠습니까?`,
  viewer_onetouch_popup_title_cash: `캐시 충전 후 대여하시겠습니까?`,
  viewer_onetouch_popup_subtitle_gidamu: `기다무 이용권을 사용할 수 없는 회차`,
  viewer_onetouch_popup_content_balance: `보유 캐시`,
  viewer_onetouch_popup_content_ticket: `대여권 (3일)`,
  viewer_onetouch_popup_button_ticket: `대여`,
  viewer_onetouch_popup_button_cash: `충전 후 대여`,
  viewer_onetouch_popup_button_options: `묶음 구매 및 소장`,
  comment_title: `<bold>댓글</bold> {{count}}`,
  comment_title_plural: `<bold>댓글</bold> {{count}}`,
  comment_empty_first: `첫 댓글을 남겨주세요.`,
  comment_account_deleted: `탈퇴한 사용자`,
  comment_unknown_user: `알 수 없는 사용자`,
  comment_see_comment_spoiler: `스포일러가 포함된 댓글 보기`,
  comment_button_dislike: `싫어요`,
  comment_button_dislike_plural: `싫어요`,
  comment_reply_title: `<bold>답글</bold> {{count}}`,
  comment_reply_title_plural: `<bold>답글</bold> {{count}}`,
  comment_write_reply_title: `답글 쓰기`,
  comment_reply: `답글`,
  comment_reply_plural: `답글`,
  comment_button_delete: `삭제`,
  comment_button_delete_popup: `선택한 댓글을 삭제하시겠어요?`,
  comment_deleted_toast: `삭제된 댓글입니다.`,
  comment_deleted_click_action_toast: `댓글이 삭제되어 요청사항을 처리할 수 없습니다.`,
  comment_button_report: `신고하기`,
  comment_report_already_report: `이미 신고가 접수되었습니다.`,
  comment_before_enter: `댓글을 입력해 주세요`,
  comment_reply_before_enter: `답글을 입력해 주세요`,
  comment_reply_more: `답글 더 보기`,
  comment_button_enter: `입력`,
  comment_button_block: `차단하기`,
  comment_block_popup_title: `{{nickname}}님을 차단하시겠어요?`,
  comment_block_popup_content: `차단한 사용자의 댓글을 확인할 수 없습니다.`,
  comment_block_toast: `해당 사용자를 차단하였습니다.`,
  comment_already_blocked_toast: `이미 차단한 사용자 입니다.`,
  comment_already_unblocked_toast: `이미 차단 해제된 사용자입니다.`,
  comment_block_displayed: `차단한 사용자의 댓글입니다.`,
  comment_button_unblock: `차단 해제하기`,
  comment_unblock_popup_title: `{{nickname}} 님을 차단 해제하시겠어요?`,
  comment_unblock_popup_content: `해제 시 사용자의 댓글을 확인하실 수 있습니다.`,
  comment_unblock_toast: `해당 사용자를 차단 해제하였습니다.`,
  comment_write_title: `댓글 쓰기`,
  comment_write_spoiler_button: `스포일러`,
  comment_write_snackbar: `댓글을 쓴 직후에 바로 추가 댓글을 쓸 수 없습니다. `,
  login_comment_write_popup: `댓글을 쓰려면 로그인 해주세요. `,
  login_comment_exceed_toast: `300자까지만 쓸 수 있습니다. `,
  comment_report_spam: `영리목적/홍보성`,
  comment_report_violence: `욕설/인신공격`,
  comment_report_illegal: `불법정보`,
  comment_report_privacy: `개인정보노출`,
  comment_report_sexual: `음란성/선정성`,
  comment_report_repeatedly: `같은 내용 도배 `,
  comment_report_rights: `권리침해 신고`,
  comment_report_piracy: `불법촬영물등 유통 신고`,
  comment_report_file_button: `신고안내`,
  comment_report_other: `기타`,
  comment_report_other_inputbox: `기타 사유를 입력해 주세요. (최대 500자)`,
  comment_report_piracy_popup_title: `계속 진행하시겠어요?`,
  comment_report_piracy_popup_content_1: `확인 버튼을 선택하여 
신고 센터에 증빙 서류를 제출해주세요.`,
  comment_report_piracy_popup_content_2: `증빙 서류를 제출하지 않을 경우
신고가 처리되지 않습니다.`,
  comment_report_submitted_toast_short: `신고가 접수되었습니다.`,
  comment_report_submitted_toast: `신고가 접수되었습니다. 
신고된 댓글은 운영 정책에 따라 처리됩니다.`,
  comment_report_read_more_button: `더 보기`,
  comment_report_rights_detail: `명예훼손, 사생활, 저작권 등의 피해가 발생한 경우
권리침해 신고센터로 증빙 서류를 제출해 주세요.`,
  comment_report_piracy_detail: `불법 촬영물등 유통 신고는 전기통신사업법 시행령에 따라, 신고인의 개인 정보 수집·이용 동의와 신고 사유 등 신고서 제출이 필요합니다.
음란, 청소년 유해 사유로 신고하시면, 신고서 제출 없이 더 빠르게 조치됩니다.`,
  comment_report_info: `불법적인 내용이거나, 서비스 이용 목적에 부합하지 않는 댓글을 신고해 주세요. 신고하신 댓글은 운영정책에 따라 처리되며, 허위 신고 시 이용에 제한을 받을 수 있습니다.`,
  comment_report: `신고하기`,
  comment_report_button: `신고하기`,
  login_comment_report_popup: `신고하려면 로그인 해주세요. `,
  comment_regulated: `규제된 댓글`,
  comment_regulated_content: `권리 침해 신고 접수에 의해 임시 조치된 글입니다.`,
  comment_policy_deleted_content: `운영정책에 의해 댓글이 삭제되었습니다.`,
  comment_regulated_content_link: `자세히 보기`,
  comment_regulated_popup_title: `운영 정책에 의해 댓글을 쓸 수 없습니다.`,
  comment_regulated_popup_date_range: `차단기간: {{start}}~{{end}}`,
  comment_regulated_popup_date_permanent: `차단기간: 영구차단`,
  comment_regulated_popup_detail_1: `차단 기간 동안 댓글 작성 외 모든 서비스 이용은 가능합니다.`,
  comment_regulated_popup_detail_2: `차단기간 종료 시, 자동으로 차단이 해제됩니다.`,
  comment_regulated_popup_detail_3: `위반 활동이 반복되는 경우 가중 처벌될 수 있습니다.`,
  comment_regulated_popup_detail_4: `궁금한 사항은 고객센터로 문의해 주세요.`,
  comment_regulated_reply_error: `규제된 글에는 답글을 쓸 수 없습니다.`,
  more_title_ticket_history: `이용권 내역`,
  ticket_history_add_tab: `충전 내역`,
  cash_history_used_detail: `유효기간이 지난 이벤트 캐시 정보로 인하여 실제 구매 취소 금액과 이용권 내역, 캐시 내역의 정보가 다를 수 있습니다.`,
  cash_history_used_rental: `대여권 {{count}}장 구매`,
  cash_history_used_rental_plural: `대여권 {{count}}장 구매`,
  cash_history_used_possession: `소장권 {{count}}장 구매`,
  cash_history_used_possession_plural: `소장권 {{count}}장 구매`,
  ticket_history_add_gift: `선물 이용권 {{count}}장`,
  ticket_history_add_gift_plural: `선물 이용권 {{count}}장`,
  ticket_history_add_gidamu: `기다무 이용권 1장`,
  cash_history_valid_date: `유효기간 {{date}}`,
  cash_history_used_rental_refunded: `대여권 {{count}}장 구매 취소`,
  cash_history_used_rental_refunded_plural: `대여권 {{count}}장 구매 취소`,
  cash_history_used_possession_refunded: `소장권 {{count}}장 구매 취소`,
  cash_history_used_possession_refunded_plural: `소장권 {{count}}장 구매 취소`,
  ticket_history_add_empty: `이용권 충전 내역이 없습니다.`,
  ticket_history_used_tab: `사용 내역`,
  ticket_history_episode_range: `{{start}}화 - {{end}}화`,
  ticket_history_used_empty: `이용권 사용 내역이 없습니다.`,
  ticket_purchase_title: `이용권 구매`,
  ticket_purchase_title_detail: `해당 작품에만 사용 가능합니다.`,
  ticket_purchase_balance_rental: `보유 대여권`,
  ticket_purchase_balance_possession: `보유 소장권`,
  ticket_purchase_ep_unread: `아직 안 본 회차 수 (무료 제외)`,
  ticket_purchase_balance_cash: `보유 캐시`,
  ticket_purchase_ineligible: `이용권을 판매하지 않는 작품입니다.`,
  ticket_purchase_rental: `<purple>대여권</purple> 구매`,
  ticket_purchase_possession: `<blue>소장권</blue> 구매`,
  ticket_purchase_all: `한 번에 구매하기`,
  ticket_purchase_bonus_1: `{{count}}장`,
  ticket_purchase_bonus_1_plural: `{{count}}장`,
  ticket_purchase_bonus_2: ` + {{count}}장 보너스`,
  ticket_purchase_bonus_2_plural: ` + {{count}}장 보너스`,
  ticket_purchase_bonus_rental_2: `{{count}}장 <purple>+ {{bonus}}장 보너스</purple>`,
  ticket_purchase_bonus_rental_2_plural: `{{count}}장 <purple>+ {{bonus}}장 보너스</purple>`,
  ticket_purchase_bonus_possession_2: `{{count}}장 <blue>+ {{bonus}}장 보너스</blue>`,
  ticket_purchase_bonus_possession_2_plural: `{{count}}장 <blue>+ {{bonus}}장 보너스</blue>`,
  ticket_purchase_rental_regulation_1: `대여 가능 기간 : 이용권 사용 후 72시간`,
  ticket_purchase_rental_regulation_2: `이용권 구매 시점이 아닌 사용 시점부터 72시간 동안 감상하실 수 있습니다.`,
  ticket_purchase_cashfriend: `지금 받을 수 있는 캐시`,
  ticket_purchase_rental_discount: `대여권 할인`,
  ticket_purchase_possession_discount: `소장권 할인`,
  ticket_purchase_discount: `할인`,
  ticket_purchase_total_count: `총 수량`,
  ticket_purchase_total_price: `상품 금액`,
  ticket_purchase_total_regulation_1: `해당 작품에만 사용 가능합니다.`,
  ticket_purchase_total_regulation_2: `보너스 이용권은 구매 취소가 되지 않습니다.`,
  ticket_purchase_cancel: `구매 취소`,
  ticket_purchase_total_limit_toast: `1회 구매 한도는 500,000 캐시 입니다.`,
  ticket_purchase_shortage: `캐시가 부족합니다.`,
  ticket_purchase_shortage_amount: `부족한 캐시`,
  more_title_cash_add: `캐시 충전`,
  ticket_purchase_shortage_add_notice: `{{value}}캐시 이상 구매할 경우, 스토어 정책에 따라 앱 내 구입 확인 팝업이 여러 번 뜰 수 있습니다. `,
  ticket_purchase_successful_rental: `대여권 {{value}}장을 구매했습니다.`,
  ticket_purchase_successful_possession: `소장권 {{value}}장을 구매했습니다.`,
  ticket_purchase_successful_balance_cash: `남은 보유 캐시: {{value}}캐시`,
  ticket_purchase_banner_title: `캐시프렌즈`,
  ticket_purchase_banner_content: `이벤트 참여하면 캐시 지급!`,
  ticket_purchase_regulation: `규정 안내`,
  ticket_purchase_regulation_1: `이용권은 캐시로 구매할 수 있습니다. 이용권을 구매 취소하면 캐시로 환급되며, 환급된 유상캐시에 대한 환불의 자세한 내용은 유료서비스 이용약관을 참고하시거나, 앱 내 고객센터 통해 문의해주세요.`,
  ticket_purchase_regulation_2: `이용권을 사용하여 콘텐츠를 열람한 이후에는 사용한 이용권에 대한 구매 취소는 불가합니다. 이용권을 사용한 후에는, 콘텐츠 발행자의 사정으로 인한 업데이트 지연, 콘텐츠 발행자의 사정으로 인한 이용권 가격 변경 등의 사유로 구매 취소할 수 없습니다. 단, 법정대리인의 동의가 없는 미성년자의 결제는 취소될 수 있습니다.`,
  ticket_purchase_regulation_3: `이용권을 사용한 이후 부정한 방법으로 캐시를 환불받은 경우, 부정하게 환불받은 금액을 회원에게 청구할 수 있으며 회사는 사전통지 없이 부정하게 환불받은 금액 내에서 회원이 보유한 캐시를 회수할 수 있습니다.`,
  ticket_purchase_regulation_4: `이용권을 사용하여 내려받은 콘텐츠는 로그인 후 이용할 수 있습니다.`,
  ticket_purchase_regulation_5: `이용권을 사용하여 내려받은 콘텐츠는 대여의 경우 72시간 동안, 소장의 경우 이용기간의 제한 없이 감상할 수 있습니다.`,
  ticket_purchase_regulation_6: `패키지상품(유료 이용권 복수 구매 시 할인된 금액에 따라 보너스 이용권을 함께 제공하는 상품)은 보너스로 지급한 이용권을 제외하고 잔여 유료 이용권만 구매 취소 가능합니다. 구매 취소시, 보너스 이용권은 자동 회수됩니다.`,
  ticket_purchase_regulation_7: `무상캐시(이벤트캐시)로 구매한 이용권은, 무상캐시의 유효기간이 만료됨에 따라 구매 취소가 불가할 수 있습니다.`,
  ticket_purchase_regulation_8: `사용하지 않은 이용권은 구매 취소할 수 있으며, 작품홈 더보기 메뉴의 작품 이용권 내역에서 가능합니다.`,
  ticket_purchase_regulation_9: `이용권 구매 및 사용에 대한 문의가 있으신 경우 앱 내 사이드 메뉴의 고객센터에서 문의 가능합니다.`,
  ticket_purchase_regulation_10: `약관을 위반한 경우 구매한 이용권의 사용에 제한을 받을 수 있으며, 자세한 내용은 이용약관/유료서비스 이용약관을 참고 바랍니다.`,
  ticket_purchase_regulation_11: `구매한 이용권의 소멸시효기간은 구매 후 5년입니다.`,
  more_title_cash_history: `캐시 내역`,
  cash_history_add_tab: `충전 내역`,
  cash_history_pass: `CASH PASS VIP`,
  cash_history_pass_banner: `신청하면 최대 {{value}}% 캐시백`,
  cash_history_pass_benefit: `{{value}}% 캐시백 혜택 받는 중`,
  cash_history_pass_detail_button: `자세히 보기`,
  cash_history_auto_aos: `카카오웹툰 웹에서 자동충전 신청하고 캐시백 받으세요. `,
  cash_history_reciept: `현금영수증`,
  cash_history_reciept_info: `현금영수증 발급 정보`,
  cash_history_add_purchased: `<gold>{{value}}캐시</gold> 구매`,
  cash_history_expiration_date: `{{value}}캐시 만료 예정 ({{date}})`,
  cash_history_expiration_date_2lines: `{{value}}캐시 
{{date}} 만료 예정`,
  cash_history_event: `이벤트 ・ {{campaign}}`,
  cash_history_cashfriends: `캐시프렌즈 ・ {{campaign}}`,
  cash_history_currency: `₩{{value}}`,
  cash_history_administrator: `관리자 회수`,
  cash_history_administrator_added: `관리자 지급`,
  cash_history_store_refunded: `스토어 환불 캐시 회수`,
  cash_history_add_coupon: `쿠폰 등록`,
  cash_history_add_coupon_detail: `쿠폰 등록 ・ {{campaign}}`,
  cash_history_add_auto_bonus: `자동충전 ・ {{value}}캐시 추가 지급`,
  cash_history_add_purchased_bonus: `캐시구매 ・ {{value}}캐시 추가 지급`,
  cash_history_minus_refunded: `{{value}}캐시 구매 취소`,
  cash_history_minus_purchased: `{{value}}캐시 구매`,
  cash_history_added_empty: `캐시 충전 내역이 없습니다. `,
  cash_history_used_tab: `사용 내역`,
  cash_history_used_detail_league: `2021년 7월 31일 이전의 내역은 <link_daum_cash>[다음웹툰 캐시]</link_daum_cash> 화면에서 확인하실 수 있습니다.`,
  cash_history_used_empty: `캐시 사용 내역이 없습니다. `,
  cash_receipt_info_empty: `등록된 정보가 없습니다. `,
  cash_receipt_info_enter_button: `등록하기`,
  cash_receipt_info_enter_indiv_phone: `개인-소득공제 (휴대폰)`,
  cash_receipt_info_enter_indiv_card: `개인-소득공제 (현금영수증 카드)`,
  cash_receipt_info_enter_business_number: `지출증빙 (사업자번호)`,
  cash_receipt_info_enter_business_card: `지출증빙 (현금영수증 카드)`,
  cash_receipt_info_enter_input_phone: `휴대폰 번호 입력 (-제외)`,
  cash_receipt_info_enter_input_card: `현금영수증 카드 번호 입력 (-제외)`,
  cash_receipt_info_enter_input_business: `사업자 번호 입력 (-제외)`,
  cash_receipt_info_enter_detail_1: `위 등록된 정보로 현금영수증이 자동 발급됩니다.`,
  cash_receipt_info_enter_detail_2: `발급된 현금영수증은 국세청 홈택스 홈페이지에서 확인 가능 합니다.`,
  cash_receipt_info_enter_agreement: `현금영수증 발급을 위한 정보 수집에 동의`,
  cash_receipt_info_enter_agreement_button: `보기`,
  cash_receipt_info_enter_register_button: `등록`,
  cash_receipt_info_enter_incomplete_phone_toast: `휴대폰 번호는 10~11자리만 가능합니다. `,
  cash_receipt_info_enter_incomplete_card_toast: `현금영수증 카드번호는 18자리만 가능합니다.`,
  cash_receipt_info_enter_incomplete_business_toast: `사업자 번호는 10자리만 가능합니다.`,
  cash_receipt_info_enter_complete_toast: `등록이 완료되었습니다.`,
  cash_receipt_in_enter_agree: `동의`,
  cash_receipt_info_delete_popup: `등록된 현금영수증 발급 정보를
삭제하시겠습니까?`,
  common_modify: `수정`,
  cash_receipt_info_price_entered: `결제금액`,
  cash_receipt_info_date_entered: `결제일시`,
  cash_receipt_info_type_entered: `종류`,
  cash_receipt_info_number_entered: `발급정보`,
  cash_receipt_info_franchise_entered: `가맹점`,
  cash_receipt_info_franchise_entered_kakao: `(주)카카오엔터테인먼트 220-88-025`,
  cash_receipt_info_cancel_amount: `취소 금액`,
  cash_receipt_info_cancel_complete: `취소 완료`,
  cash_receipt_info_consent_title: `개인정보 수집 및 이용에 대한 동의`,
  cash_receipt_info_consent_content: `(주) 카카오엔터테인먼트는 현금영수증 발급을 위해 아래와 같이 개인정보를 수집합니다.`,
  cash_receipt_info_consent_content_1: `1. 수집목적: 카카오웹툰 서비스 이용에 따른 현금영수증 발급`,
  cash_receipt_info_consent_content_2: `2. 수집항목: 휴대폰 번호, 현금영수증 카드번호, 사업자 번호 (현금영수증 발급시 등록하신 정보만 수집됩니다.)`,
  cash_receipt_info_consent_content_3: `3. 보유기간: 회원 탈퇴 후 즉시 파기 (단, 내부 정책 및 관련 법령에 의해 별도 보존이 필요한 경우 해당 기간까지 보관)`,
  cash_receipt_info_consent_content_4: `서비스 이용에 필요한 최소한의 개인정보로, 동의 거부 시 서비스 이용이 제한됩니다. 더 자세한 내용에 대해서는 <link_privacy>개인정보처리방침</link_privacy>을 참고하시기 바랍니다.`,
  cash_history_added_receipt_button: `결제 내역`,
  cash_history_added_receipt: `결제 내역`,
  cash_history_added_receipt_number: `영수증 번호`,
  cash_history_added_receipt_name: `주문자명`,
  cash_history_added_receipt_date: `발행 날짜`,
  cash_history_added_receipt_details: `결제 상세 내역`,
  cash_history_added_receipt_details_number: `주문번호`,
  cash_history_added_receipt_details_date: `일자`,
  cash_history_added_receipt_details_product_name: `상품명`,
  cash_history_added_receipt_details_product_price: `상품 금액`,
  cash_history_added_receipt_details_vat: `부가가치세`,
  cash_history_added_receipt_details_payment_total: `금액 합계`,
  cash_history_added_receipt_details_payment_method: `결제 수단`,
  cash_history_added_receipt_details_payment_method_credit_card: `Credit Card`,
  cash_history_added_receipt_details_payment_method_bank_transfer: `Bank Transfer`,
  cash_history_added_receipt_details_payment_method_fasterpay: `FasterPay`,
  cash_history_added_receipt_details_payment_method_neosurf: `Neosurf`,
  cash_history_added_receipt_details_payment_method_paysafecard: `Paysafecard`,
  cash_history_added_receipt_details_payment_method_paypal: `Paypal`,
  cash_history_added_receipt_notice_product: `상품 안내 사항`,
  cash_history_added_receipt_notice_product_detail: `((캐시 구매의 경우, 이용권을 구매해야 웹툰 열람이 가능하다는 안내사항))`,
  cash_history_added_receipt_notice_withdrawal: `구매 철회 권리 포기 안내`,
  cash_history_added_receipt_notice_withdrawal_detail: `((구매 철회 권리 포기 안내사항)) <link_cs>support_fr@kakaowebtoon.com</link_cs>>.`,
  more_title_cash_add_auto: `자동 충전`,
  cash_add_pass_benefit: `<bold>CASH PASS VIP</bold> 최대 {{value}}% 캐시백`,
  cash_add_auto_unapplied: `신청하면 최대 {{value}}% 캐시백`,
  cash_add_balance: `보유 캐시`,
  cash_add_pass: `CASH PASS VIP`,
  cash_add_pass_inuse: `이용 중`,
  cash_add_title: `<gold>캐시</gold> 충전`,
  cash_add_first_purchase_event: `첫 구매 할인 이벤트`,
  cash_add_discount_title: `캐시 할인`,
  cash_add_authentication_popup: `당월 결제 한도 초과로 본인 인증 완료 후 추가적으로 서비스를 이용할 수 있습니다. (본인 미인증 사용자: 월 최대 5만원) `,
  cash_add_authentication_button: `인증`,
  cash_add_payment_limit_popup_title: `결제 가능한 금액을 초과하였습니다.`,
  cash_add_payment_limit_popup_content: `당월 결제 한도 초과로 결제 서비스 이용이 제한됩니다. 결제 한도는 매월 1일 00:00경 초기화됩니다.`,
  cash_add_payment_limit_exceed_popup: `보유 잔여 한도를 초과하였습니다.`,
  cash_add_payment_limit_exceed_popup_content: `보유 잔여 한도는 {{value1}}캐시입니다. {{value2}}캐시까지 충전 가능합니다.`,
  cash_add_payback: `{{value}}캐시 <gold>+ {{bonus}}캐시</gold>`,
  cash_add_item_badge_recommend: `추천`,
  cash_add_item_badge_popular: `인기`,
  cash_add_agree_button: `아래 이용 안내 및 결제 진행에 동의합니다.`,
  cash_add_next_button: `다음`,
  cash_add_guides: `이용 안내`,
  cash_add_amount_popup_title: `충전 캐시 선택`,
  cash_add_auto_benefit: `자동 충전 시 {{value}}% 혜택`,
  cash_add_auto_button: `자동 충전하고 혜택받기`,
  cash_add_payment_popup_title: `결제 수단 선택`,
  cash_add_payment_popup_button: `결제`,
  cash_add_payment_processed_toast: `거래가 진행 중입니다.
잠시만 기다려주세요.`,
  cash_add_payment_processed_popup: `결제가 진행중입니다. 최대 20초가 소요될 수 있으며 결제 완료 시 자동으로 메시지는 닫힙니다. 잠시만 기다려주세요.`,
  cash_add_success_popup: `{{value}}캐시 충전이 완료되었습니다.`,
  cash_add_balance_popup: `보유 캐시: {{value}}캐시`,
  cash_add_fail_popup: `{{value}}캐시 충전에 실패했습니다.
다시 시도해 주세요.`,
  cash_add_fail_popup_content: `결제 정보가 유효하지 않습니다.`,
  cash_add_pending_toast: `결제가 완료되지 못했습니다. google store에 연결된 결제 수단에 문제가 없는지 확인해주세요. 이상이 없다면 다시 캐시 충전 화면을 실행해 주세요.`,
  cash_add_payment_processing_popup: `결제가 진행중입니다. 잠시 후 다시 확인해주세요.`,
  cash_add_auto_amount_tab: `지정 금액 충전`,
  cash_add_auto_amount_detail_balance: `보유 캐시가`,
  cash_add_auto_amount_detail_under: `미만일 경우,`,
  cash_add_auto_detail_common: `아래 금액을 자동으로 충전합니다.`,
  cash_add_auto_amount_popup_title: `하한 캐시 선택`,
  cash_add_auto_date_tab: `지정일 충전`,
  cash_add_auto_date_detail_regularly: `정기적으로`,
  cash_add_auto_date_detail: `마다`,
  cash_add_auto_benefit_bonus: `{{value}}% 혜택 <gold>+ {{bonus}}캐시</gold>`,
  cash_add_aduto_lower_amount_popup: `충전 금액은 하한 금액보다
크거나 같아야 합니다.`,
  cash_add_auto_guides_1: `자동 충전은 언제든 해지 가능합니다.`,
  cash_add_auto_guides_2: `신청 즉시 결제되며, 이용권 구매 후 보유 캐시가 설정한 금액 미만인 경우 자동 충전됩니다.`,
  cash_add_auto_guides_3: `회사 사정에 따라 보너스 캐시 지급은 변경, 중단될 수 있습니다.`,
  cash_add_auto_date_popup_title: `지정일 선택`,
  cash_add_auto_complete: `자동 충전 신청 및 결제가 완료되었습니다.`,
  cash_add_auto_complete_info_condition: `충전 조건`,
  cash_add_auto_complete_info_condition_amount: `보유 캐시 {{value}}캐시 미만`,
  cash_add_auto_complete_info_condition_date: `매월 {{value}}일`,
  cash_add_auto_complete_info_amount: `충전 금액`,
  cash_add_auto_complete_info_date: `결제일`,
  cash_add_auto_complete_info_method: `결제 수단`,
  cash_add_auto_details_button: `더 보기`,
  cash_add_auto_benefit_received: `현재까지 받은 혜택`,
  cash_add_auto_change_button: `자동 충전 조건 변경`,
  cash_add_auto_activate_button: `자동 충전 활성화`,
  cash_add_auto_purchased: `구매 항목`,
  cash_add_auto_cancel_button: `자동 충전 해지`,
  cash_add_auto_failed_activate_popup: `결제 실패로 자동 충전이 중지되었습니다.
자동 충전을 활성화 하시겠습니까?`,
  cash_add_auto_inuse_popup: `이용 중인 자동 충전이 있습니다.
조건 변경을 하실 경우
해지 후 다시 신청해 주세요.`,
  cash_add_auto_cancel: `{{user}}님, 자동 충전을
해지하시겠습니까?`,
  cash_add_auto_benefit_received_detail: `현재까지 총 <gold>{{value}} 보너스 캐시</gold>를 받았습니다.`,
  cash_add_auto_benefit_future: `앞으로 받을 혜택`,
  cash_add_auto_benefit_future_detail: `자동 충전 시 <gold>{{value}} 보너스 캐시</gold>가 지급됩니다.`,
  cash_add_auto_benefit_other: `그 외 혜택`,
  cash_add_auto_benefit_other_detail: `자동 충전 이용 고객들을 위한 <gold>특별 이벤트&혜택</gold>을 지속적으로 제공할 예정입니다.`,
  cash_add_auto_keep_button: `자동 충전 유지`,
  cash_add_auto_cancel_complete: `자동 충전 해지가 완료되었습니다.`,
  error_unsupported_browser: `해당 브라우저 버전은 지원하지 않는 버전입니다.
최신 버전 업데이트 후 이용 부탁드립니다.`,
  error_unsupported_os: `해당 OS 버전은 지원하지 않는 버전입니다.
OS 업데이트 후 이용 부탁드립니다.`,
  billing_msg_invalid_msg: `잘못된 요청입니다.`,
  billing_msg_invalid_parameter: `요청 정보가 유효하지 않습니다.`,
  billing_msg_service_fail: `알 수 없는 문제가 발생하였습니다.`,
  billing_msg_invalid_required_parameter: `필수 파라미터가 존재하지 않습니다.`,
  billing_msg_fail_get_user_info: `유저 정보 조회 실패`,
  billing_msg_invalid_user_info: `유저 정보가 유효하지 않습니다.`,
  billing_msg_invalid_user_region: `서비스 이용 국가 정보가 유효하지 않습니다.`,
  billing_msg_invalid_billing_hash: `요청 데이터 검증에 실패했습니다.`,
  billing_msg_intro_fail_get_account_balance: `캐시 잔액 조회에 실패했습니다.`,
  billing_msg_intro_fail_get_view_intro: `상품 정보 조회에 실패했습니다.`,
  billing_msg_intro_payment_policy_not_exist: `결제 이용약관 정보가 존재하지 않습니다.`,
  billing_msg_intro_payment_item_not_exist: `결제 아이템 정보가 존재하지 않습니다.`,
  billing_msg_request_invalid_price: `결제 요청 금액 정보가 유효하지 않습니다.`,
  billing_msg_request_invalid_item_id: `결제 요청 상품 정보가 유효하지 않습니다.`,
  billing_msg_request_fail_get_item_info: `상품 정보 조회에 실패했습니다.`,
  billing_msg_request_item_not_exists: `상품 정보가 존재하지 않습니다.`,
  billing_msg_request_fail_get_payment_id: `결제 정보 등록에 실패했습니다.`,
  billing_msg_request_fail_get_pg_url: `결제 정보 설정에 실패했습니다.`,
  billing_msg_result_invalid_pay_info: `결제 정보가 유효하지 않습니다.`,
  billing_msg_result_pg_fail: `충전에 실패했습니다.\n다시 시도해 주세요.`,
  billing_msg_credit_info_not_exists: `거래 정보가 존재하지 않습니다.`,
  billing_alert_check_agree: `결제 이용약관에 동의해주세요.`,
  billing_alert_invalid_price: `금액 정보가 유효하지 않습니다.`,
  billing_alert_invalid_item_info: `상품 정보가 유효하지 않습니다.`,
  billing_common_404: `요청하신 페이지를 찾을 수 없습니다.`,
  billing_msg_already_other_device_login: `다른 기기에서 로그인되어 이 기기는 로그아웃되었습니다.`,
  billing_msg_invalid_access_logout: `잘못된 접근으로 로그아웃되었습니다.`,
  billing_msg_already_login: `로그인이 필요합니다.`,
  billing_msg_web_unavailable: `캐시 충전은 앱에서만 가능합니다. 
앱으로 이동하시겠습니까?`,
  billing_msg_pc_unavailable: `캐시 충전은 앱에서만 가능합니다. 
앱설치 후 이용해주세요.`,
  billing_msg_first_puchase_only: `결제 가능한 횟수를 초과하였습니다.`,
  cash_pass_banner_title: `자동충전하면 최대 {{value}}% 캐시백`,
  cash_pass_banner_content: `웹에서 신청 가능합니다.`,
  library_tab_recent: `최근 감상`,
  library_tab_recent_phrase_default: `카카오웹툰의
인기 작품들을
만나보세요!`,
  library_tab_recent_phrase_login_genre: `{{userid}}님은
{{genre_1}}
즐겨보니까`,
  library_tab_recent_phrase_popular: `사람들이 많이 본
{{genre_1}}
작품 어떠세요?`,
  library_tab_recent_phrase_login_title: `{{userid}}님은
{{title}}
즐겨보니까`,
  library_tab_recent_phrase_nonlogin_style: `{{title}}
그림체와 유사한
작품 어떠세요?`,
  library_tab_recent_phrase_nonlogin_genre: `최근에는
{{genre_1}}
즐겨보니까`,
  library_tab_recent_phrase_nonlogin_title: `최근에는
{{title}}
즐겨보니까`,
  library_tab_recent_phrase_title: `최근에는
{{title}}
즐겨보셨군요`,
  library_tab_recent_phrase_rec: `카카오웹툰의
다른 작품들은
어떠세요?`,
  library_tab_recent_empty: `최근에 감상한 작품이 보여집니다.`,
  library_see_all_button: `전체 보기`,
  library_tab_recent_sort_recent: `감상순`,
  library_tab_recent_sort_update: `업데이트순`,
  library_tab_recent_sort_recent_toast: `감상순으로 봅니다.`,
  library_tab_recent_sort_update_toast: `업데이트순으로 봅니다.`,
  library_tab_recent_sort_download_toast: `다운로드순으로 봅니다.`,
  library_tab_recent_sort_storage_toast: `용량순으로 봅니다.`,
  library_edit_button: `편집`,
  library_select_all_button: `전체 선택`,
  library_delete_episode_button: `{{count}}개 회차 삭제`,
  library_delete_episode_button_plural: `{{count}}개 회차 삭제`,
  library_delete_content_button: `{{count}}개 작품 삭제`,
  library_delete_content_button_plural: `{{count}}개 작품 삭제`,
  library_tab_recent_delete_popup: `최근 감상 작품 {{count}}개를 
삭제하시겠습니까?`,
  library_tab_recent_delete_popup_plural: `최근 감상 작품 {{count}}개를
삭제하시겠습니까?`,
  library_tab_recent_delete_popup_v4: `작품 {{value}}개를 최근감상 목록에서 삭제하시겠어요?`,
  library_tab_recent_delete_popup_plural_v4: `작품 {{value}}개를 최근감상 목록에서 삭제하시겠어요?`,
  library_tab_recent_language_toast: `해당 작품은 {{language}}로 언어 설정 변경 후\n감상 가능합니다.`,
  library_tab_recent_language_toast_v4: `현재 언어에서는 감상할 수 없는 작품입니다.`,
  library_tab_favorites: `찜한 작품`,
  library_tab_favorites_on: `ON`,
  library_tab_favorites_off: `OFF`,
  library_tab_favorites_device_popup: `기기 알림 설정 변경을 위해
시스템 설정으로 이동합니다.`,
  library_tab_favorites_episode_popup: `회차 업데이트 알림을 켜고
업데이트 소식을 받으시겠어요?`,
  library_tab_favorites_episode_popup_button: `알림 켜기`,
  library_tab_favorites_episode_toast: `회차 업데이트 알림을 받습니다.`,
  library_before_login: `로그인 후 이용 가능합니다.`,
  library_tab_favorites_before_login: `즐겨 보는 작품을 찜하고
업데이트 알림을 받아보세요.`,
  library_tab_empty: `즐겨 보는 작품을 찜하고
업데이트 알림을 받아보세요.`,
  library_tab_favorites_available_fav: `{{count}}개
찜한 작품이
있습니다`,
  library_tab_favorites_available_fav_plural: `{{count}}개
찜한 작품이
있습니다`,
  library_tab_favorites_available_update: `{{count}}개
업데이트 작품이
있습니다`,
  library_tab_favorites_available_update_plural: `{{count}}개
업데이트 작품이
있습니다`,
  library_tab_favorites_unavailable: `찜한 작품이
없습니다`,
  library_tab_favorites_sort_update: `업데이트순`,
  library_tab_favorites_sort_added: `찜한순`,
  library_tab_favorites_sort_update_toast: `업데이트순으로 봅니다.`,
  library_tab_favorites_sort_added_toast: `찜한순으로 봅니다.`,
  library_tab_favorites_delete_title: `편집`,
  library_tab_favorites_delete_popup: `작품 {{count}}개를 찜한작품 목록에서
삭제하시겠어요?`,
  library_tab_favorites_delete_popup_plural: `작품 {{count}}개를 찜한작품 목록에서
삭제하시겠어요?`,
  library_tab_downloads: `다운로드`,
  library_tab_download_available_episode: `{{count}}개
다운로드 회차가
있습니다`,
  library_tab_download_available_episode_plural: `{{count}}개
다운로드 회차가
있습니다`,
  library_tab_download_unavailable_series: `다운로드 작품이
없습니다`,
  library_tab_download_before_login: `다운로드 받은 작품을\n오프라인 모드에서 감상하세요.`,
  library_tab_download_empty: `다운로드 받은 작품을\n오프라인 모드에서 감상하세요.`,
  library_tab_download_sort_download: `다운로드순`,
  library_tab_download_sort_storage: `용량순`,
  library_tab_download_refresh: `새로고침`,
  library_delete_title_button: `{{value}}개 작품 삭제`,
  library_tab_download_free: `무료`,
  library_tab_download_rent: `대여`,
  library_tab_download_possess: `소장`,
  library_tab_download_expired: `대여 기간 만료`,
  library_tab_download_paid: `유료 회차 전환`,
  library_tab_download_expired_toast: `대여 기간이 만료되었습니다.
감상을 위해 다시 다운로드해 주세요.`,
  library_tab_downloads_delete_popup: `다운로드 작품 {{count}}개를
삭제하시겠습니까?`,
  library_tab_downloads_delete_popup_plural: `다운로드 작품 {{count}}개를
삭제하시겠습니까?`,
  library_tab_downloads_delete_popup_v4: `작품 {{value}}개를 다운로드 목록에서 삭제하시겠어요?`,
  library_tab_downloads_delete_popup_plural_v4: `작품 {{value}}개를 다운로드 목록에서 삭제하시겠어요?`,
  library_tab_downloads_delete_ep_popup: `다운로드 회차 {{count}}개를
삭제하시겠습니까?`,
  library_tab_downloads_delete_ep_popup_plural: `다운로드 회차 {{count}}개를
삭제하시겠습니까?`,
  library_tab_downloads_delete_ep_popup_v4: `회차 {{value}}개를 다운로드 목록에서 삭제하시겠어요?`,
  library_tab_downloads_delete_ep_popup_plural_v4: `회차 {{value}}개를 다운로드 목록에서 삭제하시겠어요?`,
  library_tab_download_offline_toast: `오프라인 모드에서는 이동이 불가합니다.`,
  library_tab_download_network_popup: `네트워크 연결 상태를 확인 후
다시 시도해 주세요.`,
  offline_download_empty_title: `다운로드 작품이 없습니다.`,
  offline_download_empty_episode: `다운로드 회차가 없습니다.`,
  offline_download_network_toast: `네트워크에 연결 후 이용 가능합니다.`,
  error_network_popup_title: `네트워크가 연결되어 있지 않습니다.`,
  error_network_popup_content: `비행기 모드가 켜져 있는지, Wi-Fi나 모바일 데이터에 연결되어 있는지 확인 후 다시 시도해 주세요.`,
  library_tab_possessed: `구매 작품`,
  library_tab_possessed_available: `{{count}}개
구매 회차가
있습니다`,
  library_tab_possessed_available_plural: `{{count}}개
구매 회차가
있습니다`,
  library_tab_possessed_unavailable_series: `이용권을 구매한 작품이 보여집니다.`,
  library_tab_possessed_unavailable_episode: `구매 회차가 없습니다.`,
  library_tab_possessed_sort_update: `업데이트순`,
  library_tab_possessed_sort_possessed: `구매순`,
  library_tab_possessed_sort_update_toast: `업데이트순으로 봅니다.`,
  library_tab_possessed_sort_possessed_toast: `구매순으로 봅니다.`,
  library_tab_possessed_sort_episode_count: `{{count}}개 회차 소장`,
  library_tab_possessed_sort_episode_count_plural: `{{count}}개 회차 소장`,
  library_tab_possessed_sort_episode_free: `무료 전환 회차`,
  library_tab_possessed_sort_episode_expired: `대여기간 만료`,
  library_tab_possessed_empty: `구매 이용권으로 감상한 회차가 없습니다.`,
  library_tab_possessed_empty_ticket: `구매 이용권으로 감상한 회차가 보여집니다. 
({{count}} 장 남음)`,
  library_tab_possessed_empty_ticket_plural: `구매 이용권으로 감상한 회차가 보여집니다. 
({{count}} 장 남음)`,
  library_tab_possessed_empty_ticket_button: `작품 보러 가기`,
  library_tab_possessed_delete_popup_v4: `해당 작품이 구매작품 목록에서 숨김처리 됩니다.
다시 보시려면 편집모드에서 스위치를 켜주세요.`,
  library_tab_possessed_deleted_toast: `구매 회차를 모두 삭제했습니다.`,
  library_tab_possessed_episode_button: `{{count}}개 회차`,
  library_tab_possessed_episode_button_plural: `{{count}}개 회차`,
  library_hide_title_button: `{{count}}개 작품 숨김`,
  library_hide_title_button_plural: `{{count}}개 작품 숨김`,
  library_tab_possessed_delete_popup: `구매 작품 {{count}}개를 보관함에서 숨기겠습니까?
이용권 구매 시 다시 추가됩니다.`,
  library_tab_possessed_delete_popup_plural: `구매 작품 {{count}}개를 보관함에서 숨기겠습니까?
이용권 구매 시 다시 추가됩니다.`,
  library_tab_possessed_before_login: `구매한 작품을 확인해 보세요.`,
  library_tab_comments: `댓글`,
  library_tab_comments_unavailable: `작성한 댓글이 없습니다.`,
  library_tab_comments_delete_popup: `작성하신 댓글 {{count}}개를
삭제하시겠어요?`,
  library_tab_comments_delete_popup_plural: `작성하신 댓글 {{count}}개를
삭제하시겠어요?`,
  giftbox_cashfriend: `지금 받을 수 있는 캐시`,
  giftbox_onboarding: `지금 로그인하면
인기작 무료 이용권 선물!`,
  giftbox_tab_event: `이벤트`,
  giftbox_tab_event_participated: `지급 완료`,
  giftbox_tab_event_empty: `참여할 수 있는 이벤트가 없습니다.`,
  giftbox_tab_event_empty_global: `참여할 수 있는
이벤트가
없습니다.`,
  giftbox_ticket_gift: `선물
이용권`,
  giftbox_tab_ticket_receive_button: `{{count}}장 받기`,
  giftbox_tab_ticket_receive_button_plural: `{{count}}장 받기`,
  luckydraw_ticket_button: `작품 보러 가기`,
  giftbox_tab_ticket_received: `받기 완료`,
  giftbox_tab_ticket_empty: `받을 수 있는 선물 이용권이 없습니다. `,
  giftbox_tab_ticket_empty_global: `받을 수 있는
선물 이용권이
없습니다. `,
  giftbox_tab_ticket_empty_korea: `받을 수 있는
선물이 없습니다.`,
  giftbox_tab_received_popup: `선물 이용권 {{count}}장을 받았습니다.`,
  giftbox_tab_received_popup_plural: `선물 이용권 {{count}}장을 받았습니다.`,
  giftbox_tab_received_valid_within_popup: `유효기간: 지급일로부터 3일`,
  search_title: `검색`,
  search_main_question: `어떤 작품을
찾으세요?`,
  search_main_question_1_web: `어떤 작품을`,
  search_main_question_2_web: `찾으세요?`,
  search_input_before_enter: `작품, 작가, 장르를 입력하세요.`,
  search_recent: `최근 검색어`,
  search_recent_plural: `최근 검색어`,
  search_result_empty: `"{{value}}"
에 대한 검색 결과가 없습니다.`,
  search_result_empty_web: `에 대한 검색 결과가 없습니다.`,
  notification_title: `알림`,
  notification_tab_my: `내 소식`,
  notification_tab_gidamu: `기다리면 무료`,
  notification_tab_gidamu_complete: `한 편 무료 열람 가능`,
  notification_before_login: `로그인 후 이용 가능합니다.`,
  gidamu_notification_list_blank: `받은 알림이 없습니다.`,
  notification_list_blank: `받은 소식이 없습니다.`,
  notification_tab_notice: `공지사항`,
  notification_notice_list_deleted: `삭제된 공지사항입니다.`,
  notification_valid_specific_date: `유효기간: {{value}}까지`,
  notification_expiry_bydate: `유효기간: 지급일로부터 {{count}}일`,
  notification_expiry_bydate_plural: `유효기간: 지급일로부터 {{count}}일`,
  notification_expiry_byhour: `유효기간: 지급일로부터 {{count}}시간`,
  notification_expiry_byhour_plural: `유효기간: 지급일로부터 {{count}}시간`,
  notification_expiry_specific_date: `유효기간: {{value}}까지`,
  notification_expiry_today: `유효기간: 오늘까지`,
  notification_expiry_hour: `유효기간: 지급 시간의 59분까지`,
  notification_tab_gidamu_delete_button: `{{count}}개 알림 삭제`,
  notification_tab_gidamu_delete_button_plural: `{{count}}개 알림 삭제`,
  notification_tab_gidamu_delete_popup_title: `{{count}}개 작품의 기다리면 무료 알림을 받지 않으시겠습니까?`,
  notification_tab_gidamu_delete_popup_title_plural: `{{count}}개 작품의 기다리면 무료 알림을 받지 않으시겠습니까?`,
  notification_tab_gidamu_delete_popup_content: `기다리면 무료로 열람 시 다시 알림을 받을 수 있습니다.`,
  notification_push_waitandfree_title: `[기다리면 무료] {{value}}`,
  notification_push_waitandfree_content: `지금 바로 한 편을 무료로 감상하세요.`,
  notification_push_ticket_expire_title: `이용권 만료`,
  notification_push_ticket_expire_content: `{{title}}의 이용권 {{count}}장이 오늘 만료됩니다.`,
  notification_push_ticket_expire_content_plural: `{{title}}의 이용권 {{count}}장이 오늘 만료됩니다.`,
  notification_push_cash_expire_title: `이벤트 캐시가 곧 만료됩니다.`,
  notification_push_cash_expire_content: `만료 예정 캐시로 이용권을 구매하세요.`,
  notification_push_title_update_title: `{{value}} 업데이트`,
  notification_push_title_update_content_multiple: `'{{start}} ~ {{end}}'가 업데이트 되었습니다.`,
  notification_push_title_update_content_single: `'{{value}}'가 업데이트 되었습니다.`,
  notification_push_comment_like_title: `{{value}}님이 내 댓글을 좋아합니다.`,
  notification_push_comment_like_title_multiple: `{{count}}님 외 {{count}}명이 내 댓글을 좋아합니다.`,
  notification_push_comment_like_title_multiple_plural: `{{count}}님 외 {{count}}명이 내 댓글을 좋아합니다.`,
  notification_push_comment_reply_title: `내 댓글에 답글이 작성되었습니다.`,
  notification_push_comment_reply_content: `[{{content}} - {{episode}}]`,
  notification_push_comment_reply_event_content: `[{{value}}]`,
  notification_push_cashfriends_title: `{{value}} 참여 완료`,
  notification_push_cashfriends_content: `{{value}}캐시를 받았습니다.`,
  notification_push_gift_ticket_content: `선물 이용권을 받았습니다.`,
  notification_push_gift_cash_content: `{{value}}캐시를 받았습니다.`,
  notification_push_gift_coupon_title: `[쿠폰 등록 완료]`,
  notification_push_gift_slot_content: `지금 바로 럭키드로우(뽑기권)에 응모해 보세요.`,
  notification_push_gift_luckydraw_title: `뽑기권 당첨 선물 도착`,
  notification_push_gift_prize_title: `'{{prize}}'에 당첨되었습니다.`,
  notification_push_gift_prize_content: `당첨자에게는 개별 카톡 메세지로 안내됩니다.`,
  notification_push_popup_title_update_deleted: `삭제된 작품으로 확인이 불가합니다.`,
  notification_push_popup_event_expired: `이벤트가 종료되었습니다.`,
  notification_push_popup_common_language: `언어가 변경되어 페이지 이동이 불가능합니다. 언어 설정을 변경해 주세요.`,
  notification_raffle_page_title: `선물 도착`,
  notification_raffle_received: `선물을 받았습니다.`,
  notification_raffle_received_name: `선물`,
  notification_raffle_received_date: `지급일`,
  more_menu: `사이드 메뉴`,
  more_login_eng: `Login`,
  more_title_cash_add_auto_applied: `{{value}}% 캐시백 혜택 받는 중`,
  more_title_cash_add_auto_unapplied: `자동 충전 신청하면 최대 {{value}}% 캐시백`,
  more_title_coupon_redeem: `쿠폰 등록`,
  more_title_notification: `내 소식`,
  more_title_notice: `공지사항`,
  more_title_display_mode: `화면 스타일`,
  more_title_display_mode_dark: `다크 모드`,
  more_title_display_mode_light: `라이트 모드`,
  more_title_display_mode_system: `시스템 설정`,
  more_title_content_notification: `작품 알림`,
  more_title_content_notification_before_login: `로그인 후 이용 가능합니다.`,
  more_title_content_notification_episode: `회차 업데이트 알림`,
  more_title_content_notification_gidamu: `기다무 알림`,
  more_title_system_preferences: `사용 환경`,
  more_title_system_preferences_autoplay: `영상 자동 재생`,
  more_title_system_preferences_data: `Wi-Fi에서만 회차 감상`,
  more_title_app_setting: `설정`,
  settings_title_web: `설정`,
  more_league_korea: `웹툰리그`,
  more_login_message: `로그인하세요`,
  more_cash_add_auto_unapplied: `최대 {{value}}% 캐시백 `,
  more_cashfriends: `캐시 지금 획득 가능`,
  more_myinfo: `내 정보`,
  more_myinfo_nickname: `닉네임`,
  more_myinfo_userid: `회원번호`,
  more_myinfo_userid_copy_toast: `복사했습니다.`,
  more_myinfo_account: `내 계정`,
  more_myinfo_logout_popup: `로그아웃하시겠습니까?`,
  more_myinfo_nickname_unknown: `알 수 없음`,
  more_myinfo_nickname_change: `닉네임 수정`,
  more_myinfo_nickname_enter: `닉네임을 입력해 주세요.`,
  more_myinfo_nickname_limit_guide: `<white>{{value}}</white>/20`,
  more_myinfo_nickname_toast: `저장되었습니다.`,
  more_myinfo_nickname_banned_toast: `{{word}}는 닉네임으로 사용할 수 없습니다.`,
  more_myinfo_nickname_emoticon: `영문자,숫자와 특수기호(-),(_) 포함하여 최소 2자 이상 최대 20자 입력 가능합니다.`,
  more_myinfo_nickname_change_button: `수정하기`,
  more_myinfo_nickname_length: `20자 이내로 등록해주세요.`,
  more_myinfo_nickname_character: `영문자, 숫자,(-),(_)만 등록 가능합니다.`,
  more_myinfo_account_delete: `서비스 탈퇴`,
  more_myinfo_account_delete_precautions: `카카오웹툰 탈퇴 주의사항`,
  more_myinfo_account_delete_precautions_detail_1: `탈퇴 시 구매 이력, 이용권 사용 이력 등 모든 이용 기록 등이 즉시 삭제되며 복구할 수 없습니다.`,
  more_myinfo_account_delete_precautions_detail_2: `작성한 댓글은 탈퇴 후 '탈퇴한 회원'의 댓글로 노출됩니다. 댓글 삭제를 원하는 경우, 탈퇴 전 삭제해 주시기 바랍니다.`,
  more_myinfo_account_delete_precautions_detail_3: `탈퇴 후 사용하지 않은 이용권과 잔여 캐시는 소멸됩니다. `,
  more_myinfo_account_delete_precautions_detail_4: `앱 내 결제로 충전한 잔여 캐시를 환불하시려면 구글플레이/앱스토어에 문의해 주세요. `,
  more_myinfo_account_delete_precautions_detail_5: `탈퇴 후 7일 내 같은 계정으로 재가입 할 수 없습니다. `,
  more_myinfo_account_delete_precautions_detail_6: `카카오웹툰 서비스의 탈퇴와 카카오톡의 탈퇴는 무관합니다.`,
  more_myinfo_account_delete_agreed: `안내 사항을 모두 확인했습니다.`,
  more_myinfo_account_delete_button: `카카오웹툰 탈퇴하기`,
  more_myinfo_account_delete_confirm_popup: `탈퇴 시 보유 캐시와 이용권, 그 외\n서비스 이용 내역이 즉시 삭제됩니다.\n정말 탈퇴하시겠습니까?`,
  more_myinfo_account_delete_toast: `서비스 탈퇴가 완료되었습니다.`,
  more_help: `도움말`,
  more_help_faq: `자주 묻는 질문`,
  more_customer: `고객센터`,
  more_customer_rights_report: `권리 침해 신고 안내`,
  more_customer_title_inquiry: `서비스 문의`,
  more_customer_inquiry: `문의하기`,
  more_customer_submit: `작품 투고하기`,
  more_customer_inquiry_business: `사업 제휴 문의`,
  more_customer_inquiry_global_title: `[Help] 카카오웹툰에 문의하기`,
  more_customer_inquiry_global_question_1: `문의 내용이 무엇인가요? (이용 장애, 개선 제안 등)`,
  more_customer_inquiry_global_question_2: `문의 사항이 무엇인가요? (오류 발생 시, 진행 과정 및 발생 빈도에 대한 내용을 자세하게 기입하시면 정확한 도움을 드릴 수 있습니다.)`,
  more_customer_inquiry_global_question_3: `문제가 발생하는 화면의 스크린샷 또는 비디오를 첨부해 주시면 더 빠르고 정확하게 문제를 해결할 수 있습니다.`,
  more_customer_inquiry_info_id: `회원 번호`,
  more_customer_inquiry_info_version_app: `카카오웹툰 앱 버전`,
  more_customer_inquiry_info_browser: `브라우저`,
  more_customer_inquiry_info_device: `기기명`,
  more_customer_inquiry_info_device_language: `디바이스 설정 언어`,
  more_customer_inquiry_info_version_ios: `iOS Version`,
  more_customer_inquiry_info_version_aos: `Android version`,
  more_customer_inquiry_global_agreement_notice: `위 메일 문의를 전송하면 개인정보보호 정책 및 서비스 이용 약관에 동의한것으로 간주됩니다.`,
  more_customer_support_email_address: `support_kr@kakaowebtoon.com`,
  more_customer_support_email_address_th: `cs.th@kakaoent.com`,
  more_customer_support_email_address_tw: `support_tw@kakaowebtoon.com `,
  more_customer_inquiry_category: `문의 내용 선택`,
  more_customer_inquiry_category_detail: `문의 카테고리를 선택하여 문의하시면 보다 빠르게 답변 가능합니다. 문의 카테고리를 선택해주세요. \n\n자주 묻는 질문을 통해 서비스 기능, 이용권/캐시 환불, 계정통합 등에 대한 내용을 확인하실 수 있습니다.\n\n일시적으로 문의량이 증가하는 경우, 답변이 지연될 수 있습니다. 가능한 빠르게 확인 후 답변드릴 수 있도록 노력하겠습니다.`,
  more_customer_inquiry_category_refund_ticket: `이용권 환불 문의`,
  more_customer_inquiry_category_refund_cash: `캐시 환불 문의`,
  more_customer_inquiry_category_report_rights: `권리 침해 신고`,
  more_customer_inquiry_category_general: `일반 문의`,
  more_customer_inquiry_category_suggestions: `개선 제안`,
  more_customer_inquiry_category_problems: `이용 장애`,
  more_customer_inquiry_category_cashfriends_level: `캐시프렌즈 문의 (레벨 달성형)`,
  more_customer_inquiry_category_cashfriends_join: `캐시프렌즈 문의 (가입형)`,
  more_customer_inquiry_category_cashfriends_other: `캐시프렌즈 문의 (설치, 실행, 사전예약형)`,
  more_customer_inquiry_guide_ID: `카카오 회원 번호:`,
  more_customer_inquiry_guide_ID_detail: `내 정보에서 확인 가능합니다.`,
  more_customer_inquiry_guide_refund_series: `환불을 원하는 작품 명:`,
  more_customer_inquiry_guide_refund_price: `캐시 금액:`,
  more_customer_inquiry_guide_refund_platform: `결제한 플랫폼 (App/Web):`,
  more_customer_inquiry_guide_refund_reason: `환불 사유:`,
  more_customer_inquiry_guide_inquiries: `문의 내용:`,
  more_customer_inquiry_guide_report: `게시 중단을 요청하는 콘텐츠의 정보를 정확하게 입력해 주시기 바랍니다.`,
  more_customer_inquiry_guide_account: `카카오 계정: `,
  more_customer_inquiry_guide_report_episode: `신고 작품/회차 명:`,
  more_customer_inquiry_guide_report_publisher: `신고 작품/회차의 발행자:`,
  more_customer_inquiry_guide_questions: `문의 사항:`,
  more_customer_inquiry_guide_suggestions: `제안 내용:`,
  more_customer_inquiry_guide_problems_date: `문제 발생 일시:`,
  more_customer_inquiry_guide_problems_detail: `장애 발생 내용:`,
  more_customer_inquiry_guide_participated_date: `참여 일시:`,
  more_customer_inquiry_guide_participated_name: `참여한 이벤트 명:`,
  more_customer_inquiry_guide_purchase_date: `구매 일시:`,
  more_customer_inquiry_guide_purchase_product: `구매한 상품 명:`,
  more_customer_inquiry_guide_purchase_number: `주문 번호:`,
  more_customer_inquiry_guide_name: `이름:`,
  more_customer_inquiry_guide_birthdate: `생년월일:`,
  more_customer_inquiry_refund_ticket_input_detail: `*무료 이용권은 환불 대상이 아니며, 이벤트 캐시로 구매한 이용권은 해당 캐시의 유효기간이 만료된 경우 환불이 불가합니다. `,
  customer_inquiry_category_select: `문의 카테고리를 선택해 주세요.`,
  customer_inquiry_category_service: `서비스 관련 문의`,
  customer_inquiry_category_content: `작품 관련 문의`,
  customer_inquiry_category_payment: `결제 관련 문의`,
  customer_inquiry_category_other: `기타 문의`,
  customer_inquiry_guide_default: `문의 카테고리를 선택 후 내용을 입력해주세요.`,
  customer_inquiry_guide_enter: `내용을 입력해 주세요.`,
  more_customer_inquiry_answer_number: `답변 받을 휴대폰 번호`,
  more_customer_inquiry_answer_number_error: `휴대번호를 정확하게 입력해 주세요.`,
  more_customer_inquiry_answer_email: `답변 받을 이메일 주소`,
  more_customer_inquiry_answer_email_detail: `문의 접수 시 회원 번호(로그인 유저만 수집), 디바이스 or 웹 브라우저 정보, 앱 버전, os 버전이 함께 수집됩니다. `,
  more_customer_inquiry_answer_email_error: `이메일 주소를 정확하게 입력해 주세요.`,
  more_customer_inquiry_country: `국가 선택`,
  more_customer_inquiry_attachment: `첨부파일 추가`,
  more_customer_inquiry_attachment_button: `추가`,
  more_customer_inquiry_attachment_detail_2: `파일 형식은 이미지 파일(jpg, png)와 docx, doc 파일만 등록 가능합니다.`,
  more_customer_inquiry_attachment_detail: `파일은 최대 5개, 10MB 이하로 첨부가능합니다.`,
  more_customer_inquiry_guide_attachment_app: `문의와 함께 첨부할 파일이 있는 경우, cs_kr@kakaowebtoon.com 로 문의해 주세요.`,
  more_customer_inquiry_guide_attachment_web: `전달할 파일 첨부가 실패할 경우, cs_kr@kakaowebtoon.com 로 접수해 주세요.`,
  more_customer_inquiry_file_attached_toast: `파일이 첨부 되었습니다.`,
  more_customer_inquiry_file_deleted_toast: `파일이 삭제 되었습니다.`,
  more_customer_inquiry_agreement_title: `개인 정보 수집 동의 및 내용 안내`,
  more_customer_inquiry_agreement_1: `문의 사항에 대한 원인 확인 및 상담을 위하여 이메일, 휴대번호를 수집합니다.`,
  more_customer_inquiry_agreement_2: `문의 유형에 따라 광고 식별자 (ADID, IDFA)와 기기 정보, 생년월일 정보를 추가로 수집할 수 있습니다.`,
  more_customer_inquiry_agreement_3: `수집된 개인 정보는 문의 접수일 기준 3년간 보관 후 파기됩니다.`,
  more_customer_inquiry_agreement_check: `위 내용에 동의합니다.`,
  more_customer_inquiry_send_button: `보내기`,
  more_customer_inquiry_send_toast: `문의 사항을 전송했습니다.`,
  more_customer_inquiry_send_failed_toast: `문의 사항 전송에 실패했습니다. 다시 시도해주세요.`,
  more_customer_inquiry_send_unselected_toast: `문의 카테고리 선택 후 입력해 주세요.`,
  more_customer_inquiry_history: `문의 내역 확인`,
  more_customer_inquiry_history_detail: `최근 1년 내 이력만 조회 가능합니다.`,
  more_customer_inquiry_history_empty: `문의 내역이 없습니다.`,
  more_serviceinfo: `서비스 정보`,
  more_serviceinfo_terms: `약관 및 정책`,
  more_serviceinfo_terms_cookie: `쿠키 수집 정책`,
  more_serviceinfo_terms_use: `서비스 이용약관`,
  more_serviceinfo_terms_personal: `개인정보처리방침`,
  more_serviceinfo_terms_youth: `청소년 보호 정책`,
  more_serviceinfo_terms_operational: `운영 정책`,
  more_serviceinfo_terms_payment: `유료 서비스 이용약관`,
  more_serviceinfo_terms_payment_policy: `결제 서비스 운영 정책`,
  more_serviceinfo_terms_customized: `맞춤형 광고 안내`,
  more_serviceinfo_openlicense: `오픈 라이선스`,
  more_serviceinfo_business: `사업자 정보`,
  more_serviceinfo_business_name_company: `상호`,
  more_serviceinfo_business_name_corporation: `주식회사 카카오 엔터테인먼트`,
  more_serviceinfo_business_name_representative: `공동대표이사`,
  more_serviceinfo_business_name_representative_detail: `권기수, 장윤중`,
  more_serviceinfo_business_name_manager: `출판물 관리자`,
  more_serviceinfo_business_name_manager_detail: `이주원`,
  more_serviceinfo_business_capital: `자본금`,
  more_serviceinfo_business_capital_detail: `19,596,888,000원`,
  more_serviceinfo_business_registration_number: `사업자 등록 번호`,
  more_serviceinfo_business_registration_number_detail: `220-88-02594`,
  more_serviceinfo_business_mail_order: `통신판매업 신고 번호`,
  more_serviceinfo_business_mail_order_detail: `2018-성남분당B-0004`,
  more_serviceinfo_business_address: `주소`,
  more_serviceinfo_business_address_detail: `경기도 성남시 분당구 판교역로 221 (삼평동, 투썬월드빌딩 6층)`,
  more_serviceinfo_business_phone: `대표전화`,
  more_serviceinfo_business_phone_detail: `1644-4755`,
  more_serviceinfo_business_email: `전자우편 주소`,
  more_serviceinfo_business_email_detail: `contact@kakaoent.com`,
  more_serviceinfo_business_host: `호스팅 서비스 사업자`,
  more_serviceinfo_business_host_detail: `Amazon Web Services Korea LLC / (GS Tower, Yeoksam-dong) 13F, 508, Nonhyeon-ro, Gangnamgu, Seoul, Republic of Korea`,
  more_serviceinfo_version: `앱 버전 안내`,
  more_serviceinfo_version_latest: `최신 버전`,
  more_serviceinfo_version_current: `현재 버전`,
  more_serviceinfo_version_update: `최신 버전 업데이트`,
  more_serviceinfo_version_latest_inuse: `최신 버전 사용 중`,
  more_serviceinfo_version_minsdk_change_title: `OS 최소 지원 버전 상향 안내`,
  more_serviceinfo_version_minsdk_change_content: `보다 안정적이고 원활한 서비스 제공을 위해, OS 최소 지원 버전을 {{value}}으로 상향했습니다.

{{value}} 미만 버전에서는 앱 업데이트가 불가하며, 추후 사용 중인 앱이 지원 중단 대상에 포함될 경우 서비스 이용이 불가한 점 양해 부탁드립니다.`,
  more_serviceinfo_version_minsdk_changed_title: `구버전 지원 중단 안내`,
  more_serviceinfo_version_minsdk_changed_content: `구매 회차 감상 및 보유중인 구매 이용권 환불은 카카오웹툰 웹에서 진행 가능합니다. 보다 안정적인 서비스 제공을 위한 결정임을 양해해 주시기 바랍니다.`,
  more_serviceinfo_version_minsdk_changed_gotoweb: `웹으로 이동`,
  redeem_coupon_before_enter: `쿠폰번호를 입력해 주세요.`,
  redeem_coupon_before_register_button: `등록하기`,
  redeem_coupon_policy: `쿠폰 등록 유의사항`,
  redeem_coupon_inquiry: `고객센터 문의하기`,
  redeem_coupon_policy_detail_1: `유효기간이 지난 경우 등록되지 않습니다.`,
  redeem_coupon_policy_detail_2: `등록된 쿠폰은 교환/환불 혹은 현금으로 환급되지 않습니다.`,
  redeem_coupon_policy_detail_3: `쿠폰 등록을 통해 지급받은 선물은 '알림-내소식'에서 확인 가능합니다.`,
  redeem_coupon_policy_detail_3_v4: `쿠폰 등록을 통해 지급받은 선물은 '사이드메뉴 - 내소식'에서 확인 가능합니다. `,
  redeem_coupon_toast_success: `쿠폰 등록이 완료되었습니다.
내 소식에서 선물을 확인하세요.`,
  redeem_coupon_toast_fail_invalid_checkagain: `쿠폰 번호가 올바르지 않습니다. 쿠폰 번호를 다시 확인해 주세요.`,
  redeem_coupon_toast_fail_used: `이미 사용된 쿠폰입니다.`,
  redeem_coupon_toast_fail_sametype: `같은 종류의 쿠폰은 1회만 등록 가능합니다. `,
  redeem_coupon_toast_fail_ineligible: `쿠폰 지급 대상자가 아닙니다.`,
  redeem_coupon_toast_fail_expired: `쿠폰의 유효기간이 만료되었습니다.`,
  redeem_coupon_toast_fail_invalid: `유효하지 않은 쿠폰입니다.`,
  redeem_coupon_toast_fail_ranout: `지급 가능한 쿠폰이 모두 소진되었습니다.`,
  redeem_coupon_toast_fail_used_device: `동일한 기기에서 이미 수령했습니다.`,
  settings_title: `설정`,
  settings_system_preferences: `사용자 환경 설정`,
  settings_notifications: `알림 설정`,
  settings_notifications_content: `전체 알림이 꺼져 있습니다.`,
  settings_notifications_device: `기기 알림 설정`,
  settings_notifications_device_detail: `앱에서 보내는 알림을 받습니다.`,
  settings_notifications_toast: `기기 알림 활성화 후 이용 가능합니다.`,
  settings_notifications_aos_toast: `전체 알림 받기 활성화 후 이용 가능합니다.`,
  settings_notifications_ios_popup: `기기 알림 설정 변경을 위해
시스템 설정으로 이동합니다.`,
  settings_notifications_marketing: `이벤트 및 작품 추천 알림`,
  settings_notifications_marketing_detail: `작품 추천 및 이벤트 알림을 받습니다.`,
  settings_notifications_marketing_detail_320: `작품 추천 및 이벤트 알림을 받습니다.`,
  settings_notifications_marketing_on_toast: `{{value}} 카카오웹툰
이벤트 및 작품추천 알림 수신 동의`,
  settings_notifications_marketing_on_toast_320: `{{value}} 카카오웹툰
이벤트 및 작품추천 알림 수신 동의`,
  settings_notifications_marketing_off_toast: `{{value}} 카카오웹툰 
이벤트 및 작품추천 알림 수신 거부`,
  settings_notifications_marketing_off_toast_320: `{{value}} 카카오웹툰 
이벤트 및 작품추천 알림 수신 거부`,
  settings_notifications_email: `이메일로 이벤트 및 작품 추천 받기`,
  settings_notifications_email_detail: `가입 시 사용한 이메일로 이벤트 및 작품 추천 정보를 받습니다.`,
  settings_notifications_app: `앱 푸시로 이벤트 및 작품 추천 받기`,
  settings_adid_aos: `맞춤형 광고 최적화 설정`,
  settings_adid_aos_popup: `서비스 마케팅 효율 분석 목적으로 당사 및 타 웹사이트에서 귀하의 데이터를 사용할 수 있습니다.`,
  adid_popup_button_activate: `활성화`,
  adid_popup_button_inactivate: `비활성화`,
  settings_notifications_device_off: `기기 알림이 꺼졌습니다.\n다시 설정해 주세요.`,
  settings_notifications_login_toast: `로그인 후 이용 가능합니다.`,
  settings_notifications_updates: `회차 업데이트 알림`,
  settings_notifications_updates_detail: `찜한 작품의 회차 업데이트 알림을 받습니다.`,
  settings_notifications_ticket: `기다무 이용권 충전 완료 알림`,
  settings_notifications_likes_comment_global: `댓글 좋아요 알림`,
  settings_notifications_likes_reply_global: `댓글 대댓글 알림`,
  settings_notifications_likes_reply_global_320: `댓글 대댓글 알림`,
  settings_notifications_sleepmode_global: `슬립모드 설정`,
  settings_notifications_sleepmode_global_info: `설정한 시간에 알림을 받지 않습니다.`,
  settings_notifications_sleepmode_global_start: `슬립모드 시작 시간`,
  settings_notifications_sleepmode_global_end: `슬립모드 종료 시간`,
  settings_notifications_sleepmode_global_pm: `오후 {{time}}`,
  settings_notifications_sleepmode_global_am: `오전 {{time}}`,
  settings_notifications_nighttime_korea: `야간 혜택 알림 (21시~08시)`,
  settings_notifications_nighttime_korea_detail: `21시~08시 사이 혜택 알림 푸시를 받습니다.`,
  settings_notifications_nighttime_korea_on_toast: `{{year}}년 {{month}}월 {{day}}일 카카오웹툰\n야간 혜택 알림 수신 동의`,
  settings_notifications_nighttime_korea_off_toast: `{{year}}년 {{month}}월 {{day}}일 카카오웹툰\n야간 혜택 알림 수신 거부`,
  settings_cookie: `쿠키 설정`,
  settings_cookie_title: `웹 사이트 방문 정보가 브라우저에서 쿠키 형태로 저장되거나 수집될 수 있습니다.`,
  settings_cookie_content: `본 정보는 개인화된 웹 경험을 제공하기 위해 사용되고 있으며, 귀하의 선호도에 따라 일부 쿠키를 거부할 수 있습니다. 쿠키 수집에 대한 자세한 내용은 <link_privacy>개인정보처리방침</link_privacy>에서 확인 가능합니다.`,
  settings_cookie_required: `서비스 이용을 위한 쿠키 <red>(필수)</red>`,
  settings_cookie_required_detail: `서비스 이용에 필수로 수집이 필요한 쿠키를 수집합니다. 웹사이트 세션 로그인 또는 서비스 통계에 대한 최소한의 것들이 수집되며 이를 수집 거부하는 경우 서비스를 이용 할 수 없습니다.`,
  settings_cookie_analytics: `분석용 쿠키 수집`,
  settings_cookie_analytics_detail: `서비스 개선 사항을 파악하기 위해 접속 디바이스, 브라우저의 종류 및 서비스를 이용하면서 발생된 에러에 대한 로그 등을 수집합니다.`,
  settings_cookie_third_party: `광고 효율을 위한 쿠키 수집`,
  settings_cookie_third_party_detail: `카카오웹툰 광고 파트너가 설정하는 쿠키이며, 카카오웹툰의 콘텐츠 및 광고를 Facebook 등의 SNS에 추천하는데 사용됩니다.`,
  settings_data: `데이터 설정`,
  settings_data_wifi_view: `Wi-Fi 환경에서만 회차 감상`,
  settings_data_wifi_download: `Wi-Fi 환경에서만 회차 다운로드`,
  settings_autoplay: `영상 자동 재생`,
  settings_autoplay_on: `켜짐`,
  settings_autoplay_off: `꺼짐`,
  login_register_device_popup: `기기 등록을 위해 
로그인이 필요합니다.`,
  settings_device_empty: `등록된 기기가 없습니다.`,
  settings_device_registered: `{{value}}개 등록 중`,
  settings_device_register: `기기 등록하기`,
  settings_device_deregister: `기기 해제하기`,
  settings_device_register_success_toast: `기기가 등록되었습니다.`,
  settings_device_register_fail_toast: `기기 등록에 실패했습니다. 다시 시도해 주세요.`,
  settings_device_registered_toast: `이미 등록된 기기입니다.`,
  settings_device_deregister_toast: `기기가 해제되었습니다.`,
  settings_device_register_continue_popup_title: `기기 등록 해제를 진행하시겠습니까?`,
  settings_device_register_continue_popup_content: `이번 달 기기 해제 횟수가 차감됩니다.`,
  settings_device_register_impossible_popup: `이번 달 사용 가능한\n기기 해제 횟수를 모두 소진하여\n해제가 불가합니다.`,
  settings_device_detail_1: `회차 다운로드를 위해 기기 등록이 필요합니다.`,
  settings_device_detail_2: `ID 당 2개의 기기만 등록 가능합니다.`,
  settings_device_detail_3: `기기 해제는 월 1회 가능합니다. (해제 가능 횟수 {{value}}회 남음)`,
  settings_device_detail_4: `이번 달 기기 해제 가능 횟수 초과 시 새로운 기기 등록/해제는 다음 달 1일부터 가능합니다.`,
  settings_device_info_in_use_registered: `등록된 기기 사용 중`,
  settings_device_info_in_use_unregistered: `계정에 연결된 다른 기기 사용 중`,
  settings_device_registered_date: `{{date}} 등록`,
  settings_device_info_deregister_button: `해제`,
  settings_tracking_ios: `추적 허용 설정`,
  settings_tracking_ios_popup: `추적 허용을 활성화 시
더 많은 이벤트에 참여 가능합니다.
활성화 하시겠습니까?`,
  settings_tracking_on_ios_toast: `추적 허용 설정은 기기 설정 > 카카오웹툰에서 변경 가능합니다.`,
  settings_tracking_on_ios_oldversion_toast: `iOS 14 이상에서 사용 가능한 기능입니다.`,
  settings_language: `언어 설정`,
  settings_language_popup_title: `언어를 {{language}}로 변경하시겠습니까?`,
  settings_language_popup_content: `감상 가능한 작품이 변경될 수 있습니다.`,
  settings_language_popup_content_app: `언어 변경 시 감상 가능한 작품이 변경될 수 있으며, 언어 변경을 위해 앱이 재실행 됩니다.`,
  settings_language_popup_content_web: `언어 변경 시 감상 가능한 작품이 변경될 수 있습니다.`,
  region_language_change_settings_popup: `전체 언어 변경을 위해 앱을 재실행합니다.`,
  settings_manage_space: `저장 공간 관리`,
  common_stroage_used_kb: `<bold>{{used}} KB</bold> / {{max}} GB`,
  common_stroage_used_mb: `<bold>{{used}} MB</bold> / {{max}} GB`,
  common_stroage_used: `<bold>{{used}} GB</bold> / {{max}} GB`,
  settings_manage_space_delete_downloads_button: `저장 콘텐츠 전체 삭제`,
  settings_manage_space_delete_downloads_popup_title: `앱에 저장한 콘텐츠를 모두
삭제하시겠습니까? `,
  settings_manage_space_delete_downloads_popup_content: `개별 삭제는 '보관함 > 다운로드' 탭에서 가능합니다.`,
  settings_manage_space_delete_cash_button: `캐시 데이터 삭제`,
  settings_manage_space_delete_cash_toast: `캐시가 모두 삭제되었습니다.`,
  settings_manage_space_autodelete: `자동 삭제 기간 설정`,
  settings_manage_space_autodelete_10d: `10일`,
  settings_manage_space_autodelete_popup_title: `자동 삭제 기간을 10일로
변경하시겠습니까?`,
  settings_manage_space_autodelete_popup_content: `변경 시 10일이 지난 콘텐츠는 삭제됩니다.`,
  settings_viewer: `작품 감상 설정`,
  settings_viewer_sort: `회차 정렬`,
  settings_viewer_sort_date: `최신 화부터`,
  settings_viewer_sort_episode: `첫 화부터`,
  settings_viewer_type: `회차 목록`,
  settings_viewer_type_thumbnai: `섬네일 타입`,
  settings_viewer_type_list: `리스트 타입`,
  settings_viewer_resolution: `뷰어 화질`,
  settings_viewer_resolution_high: `고화질 `,
  settings_viewer_resolution_low: `저화질`,
  settings_display_mode: `화면 스타일 설정`,
  settings_display_mode_dark: `다크 모드`,
  settings_display_mode_light: `라이트 모드`,
  settings_display_mode_system: `시스템 설정`,
  settings_privacy: `개인 정보 보안 설정`,
  settings_privacy_tracking: `추적 허용 설정`,
  settings_privacy_optional_terms: `선택 약관 동의 정보`,
  settings_privacy_optional_terms_thirdparty: `마케팅 활용 개인정보 제 3자 제공 동의`,
  settings_privacy_optional_terms_thirdparty_detail: `카카오 서비스 내 이벤트 및 광고 등 마케팅 활용 목적으로 카카오에 개인정보 제공을 동의합니다. `,
  settings_privacy_optional_terms_thirdparty_detail_1: `동의를 거부하실 경우 이벤트 및 광고 서비스 이용이 제한될 수 있습니다.`,
  settings_privacy_optional_terms_thirdparty_detail_2: `동의를 철회한 이후에도 재동의가 가능합니다.`,
  settings_privacy_optional_terms_thirdparty_detail_3: `약관에 동의하실 경우, 제공되는 정보에 대한 상세 내용은 '<link_thirdparty>(선택) 마케팅 활용을 위한 개인정보 제 3자 제공동의</link_thirdparty>'를 참고해 주시기 바랍니다.`,
  login_auto_toast: `자동 로그인 중입니다. 잠시 후 다시 시도해 주세요. `,
  login_adult_toast: `본 작품은 청소년에게 적합하지 않은 내용을 담고 있어 감상이 불가합니다.`,
  login_popup: `로그인 후 이용 가능합니다.`,
  login_action_adult_popup: `성인 작품 감상을 위해
로그인이 필요합니다.`,
  login_action_view_gidamu_episode_popup: `지금 로그인 하고 무료로 감상하세요.`,
  login_action_view_next_ep_popup: `다음 회차 감상을 위해
로그인이 필요합니다.`,
  login_global_unsubscribe_popup: `이메일 수신 거부를 위해 로그인 해주세요.`,
  deleted_account_popup: `탈퇴한 계정입니다. 탈퇴 7일 후에 재가입 할 수 있습니다. `,
  inactive_user_popup_title: `회원님의 계정은 현재 휴면 상태입니다.`,
  inactive_user_popup_content: `1년 이상 로그인 하지 않아 계정이 휴면 상태로 전환되었습니다. 휴면 해제를 위해 확인 버튼을 눌러 로그인 해주세요.`,
  blocked_user_popup_title: `운영 정책에 따라 로그인이 차단되었습니다. `,
  blocked_user_popup_content: `차단 사유 확인 및 해제 요청은 고객센터에 문의해 주세요.`,
  blocked_user_popup_content_cs: `<link_cs>고객센터 문의하기</link_cs>`,
  new_user_login_popup_web: `신규 가입이신가요?
앱에서 가입하면 선물을 드려요!`,
  new_user_login_popup_button_web: `앱에서 가입`,
  new_user_login_popup_continue_web: `계속하기`,
  login_global_onboarding_popup: `카카오웹툰을 시작하기 위해 
가입/로그인해 주세요.`,
  login_global_gidamu_popup: `지금 로그인 하고 무료로 감상하세요.`,
  login_global_popup: `서비스 이용을 위해 로그인해 주세요.`,
  login_global_existing_account_popup: `{{existing}}으로 로그인하신 이력이 있습니다.`,
  login_global_account_google: `구글 계정으로 로그인`,
  login_global_account_apple: `애플 계정으로 로그인`,
  login_global_account_facebook: `페이스북 계정으로 로그인`,
  login_global_account_line: `라인 계정으로 로그인`,
  login_global_account_twitter: `트위터 계정으로 로그인`,
  login_global_existing_other_option_button: `다른 옵션 보기`,
  login_global_existing_different_signin_button: `다른 계정으로 로그인`,
  login_global_create_account_popup: `계정 만들고 계속하기`,
  login_global_have_account_popup: `계정이 있으신가요?`,
  login_signin_button: `로그인`,
  login_signup_page_title: `카카오웹툰 이용약관`,
  login_signup_description_title: `카카오웹툰 이용을 위해`,
  login_signup_description_content: `약관에 동의해 주세요.`,
  login_signup_agree_all: `전체 동의`,
  login_new_signup_button: `확인`,
  login_global_signup_agree_termsofuse: `카카오웹툰 서비스 이용약관에 동의합니다. <grey>(필수)</grey>`,
  login_global_signup_termsofuse_page_title: `이용약관`,
  login_global_signup_agree_privacy: `카카오웹툰의 개인정보처리방침에 동의합니다. <grey>(필수)</grey>`,
  login_global_signup_privacy_page_title: `개인정보처리방침`,
  login_global_signup_agree_data_transfer: `개인정보 국외 전송에 대해 동의합니다. (자세한 내용은 Privacy Policy를 참고해 주세요.) <grey>(필수)</grey>`,
  login_global_signup_agree_age: `나는 18세 이상입니다. <grey>(필수)</grey>`,
  login_global_signup_privacy_dob: `* {{value}}세 이상 가입 가능 합니다. 생년월일을 입력해주세요. `,
  login_global_signup_privacy_dob_alert: `* 생년월일을 입력해주세요.`,
  login_global_signup_privacy_dob_guide: `년/월/일`,
  login_global_signup_privacy_dob_entered: `{{year}}/{{month}}/{{day}}`,
  login_global_signup_optional_notification: `이벤트 및 작품 추천 알림 수신 동의 <grey>(선택)</grey>`,
  login_global_signup_required_notification: `이벤트 및 작품 추천 알림 수신 동의 
(설정을 통해 언제든 푸시 알림을 끌 수 있습니다.) <grey>(필수)</grey>`,
  login_global_signup_optional_email: `이메일로 이벤트 및 작품 추천 소식 받기 <grey>(선택)</grey>`,
  login_global_signup_privacy_detail: `(문구 확정 전) 하단 개인정보처리방침 안내문 관련 내용이 들어갈 예정입니다. <link_privacy>ici</link_privacy>`,
  login_global_signup_privacy_dob_popup: `{{value}}세 이상 가입 가능합니다. 생년월일 정보를 다시 확인해주세요.`,
  login_global_signup_agree_required_sentence: `가입을 위해 위 약관에 동의해 주세요.`,
  login_another_device_popup: `다른 기기에 로그인 되어있습니다.
다른 기기의 연결을 해제하고 지금 기기에서 접속하시겠습니까?`,
  login_global_signedup_web: `다른 언어에서 가입된 계정입니다. 가입한 언어의 웹페이지로 이동하시겠습니까?`,
  login_global_signedup_web_button: `이동하기`,
  login_global_signedup_app: `가입된 언어가 현재 언어와 달라 전체 언어 변경이 진행되며, 언어 변경을 위해 앱을 재실행해주세요.`,
  login_global_signedup_app_button: `재실행`,
  login_global_signedup_region_popup: `{{region}} 리전에서 가입한 계정입니다. 가입 리전의 서비스로 변경하시겠습니까? 리전 변경시 앱이 종료됩니다.`,
  login_global_signedup_region_popup_button: `리전 변경하기`,
  region_country_select_taiwan: `台灣`,
  region_country_select_thailand: `ไทย`,
  region_country_select_france: `프랑스`,
  region_country_select_indonesia: `인도네시아`,
  region_country_select_korea: `한국`,
  login_forced_logout_popup: `다른 기기에서 로그인되어\n이 기기는 로그아웃되었습니다.`,
  login_restricted_popup_title: `로그인과 회원가입이 일시적으로 제한되었습니다.`,
  login_restricted_popup_content: `이 디바이스에서 다수의 계정이 단 기간에 로그인되어 보안 상 이유로 일시적 가입/로그인이 제한되었습니다. 기존에 로그인했던 계정으로 로그인 부탁드립니다. 신규 계정 가입/로그인을 원할 경우  고객센터로 문의해 주세요.`,
  login_restricted_help_popup: `도움이 필요하신가요? <bold-link_cs>Contact Us</bold-link_cs>`,
  login_adult_verify_popup: `본 작품은 청소년에게 적합하지 않은 내용을 포함하고 있어 19세 이상만 감상 가능합니다. 
19세 이상입니까? `,
  error_code_3000_toast: `인증 정보 갱신을 위해 다시 로그인 해주세요.`,
  login_blocked_toast: `로그인을 여러 번 시도하여 잠시 로그인이 차단되었습니다. 잠시 후 다시 시도해 주세요.`,
  login_global_withdraw_consent_popup_title: `약관 동의 철회 계정입니다.`,
  login_global_withdraw_consent_popup_content: `약관 동의가 철회되어 로그아웃 되었습니다. 서비스 이용을 위해 로그인 후 약관에 동의해주세요.`,
  login_global_reconsent_title: `카카오웹툰 이용을 위해
약관에 동의해 주세요.`,
  authentication_korea_purchase_limit_popup_title: `본인 인증 없이 결제 가능한 금액을 초과하였습니다.`,
  authentication_korea_purchase_limit_popup_content: `추가 결제를 위해 본인 인증이 필요합니다.
본인 인증 정보는 카카오웹툰에 저장되며 변경할 수 없습니다. 반드시 본인 명의의 휴대폰 번호로 인증해 주세요.`,
  authentication_korea_autopurchase_popup_title: `자동충전 이용을 위해 본인인증이 필요합니다.`,
  authentication_korea_autopurchase_popup_content: `본인인증 정보는 카카오웹툰에 저장되며 변경할 수 없습니다. 반드시 본인 명의의 휴대폰 번호로 인증해 주세요.`,
  authentication_korea_agree: `카카오웹툰 개인정보수집 및 이용 동의`,
  authentication_korea_view_ep_popup_title: `감상을 위해 본인 인증이 필요합니다.`,
  authentication_korea_view_ep_popup_content: `청소년에게 적합하지 않은 내용을 포함하고 있어 감상을 위해 성인 인증이 필요합니다.
본인 인증 정보는 카카오웹툰에 저장되며 변경할 수 없습니다. 반드시 본인 명의의 휴대폰 번호로 인증해 주세요.`,
  authentication_korea_consent_button: `(필수) 카카오웹툰 개인정보 수집 및 이용 동의`,
  authentication_korea_show_button: `보기`,
  authentication_korea_continue_button: `인증 진행`,
  authentication_korea_toast: `본인 인증 진행을 위해 개인정보 수집 및 이용에 동의해주세요.`,
  authentication_korea_page_title_privacy: `개인정보 처리 방침`,
  authentication_korea_page_title_authentify: `본인 인증`,
  authentication_korea_failed_toast: `인증에 실패했습니다.`,
  authentication_korea_failed_under17_toast: `보호자와 나이차가 18세 미만으로 확인되어 인증에 실패했습니다.`,
  authentication_global_popup_title: `감상을 위해 생년월일을 입력해주세요.`,
  authentication_global_popup_content: `본 작품은 청소년에게 적합하지 않은 내용을 포함하고 있어 18세 이상만 감상 가능합니다. 연령 확인을 위해 생년월일을 입력해 주세요.`,
  authentication_global_adult_toast: `18세 이상만 감상 가능합니다.`,
  authentication_global_succeed_adult_toast: `{{n}}으로 연령 인증되었습니다.`,
  authentication_global_failed_adult_toast: `18세 이상만 감상 할 수 있는 작품입니다.`,
  authentication_global_confirm_popup_content: `입력하신 생년월일은 {{value}}입니다. 인증을 진행하시겠습니까? `,
  login_korea_kakao: `카카오 로그인`,
  login_korea_kakao_enter: `카카오계정 직접 입력`,
  login_korea_daum: `다음ID로 다음웹툰을 이용했다면?`,
  login_korea_signup_over_14: `만 14세 이상입니다.`,
  login_korea_signup_required_termsofuse: `(필수) 카카오웹툰 서비스 이용약관`,
  login_korea_signup_required_privacy: `(필수) 카카오웹툰 개인정보 처리방침`,
  login_korea_signup_required_paid: `(필수) 카카오웹툰 유료 서비스 이용약관`,
  login_korea_signup_required_paid_title: `유료 이용약관`,
  login_korea_signup_required_privacy_thirdparty: `(필수) 카카오웹툰 개인정보 제 3자 정보 제공 동의`,
  login_korea_signup_required_privacy_thirdparty_title: `(필수) 개인정보 제 3자 정보 제공 동의`,
  login_korea_signup_optional_privacy_thirdparty: `(선택) 마케팅 활용을 위한 개인정보 제 3자 정보 제공 동의`,
  login_korea_signup_optional_privacy_thirdparty_title: `(선택) 개인정보 제 3자 정보 제공 동의`,
  login_korea_signup_optional_notification_event: `(선택) 이벤트 및 작품 추천 알림 수신 동의`,
  login_korea_signup_optional_notification_nighttime: `(선택) 야간(21시~08시) 알림 수신 동의`,
  login_korea_signup_optional_channel: `(선택) 카카오웹툰의 광고 메시지를 카카오톡으로 받기`,
  login_korea_signup_under_14_popup: `만 14세 미만 아동 여부를 확인하기 위해 본인 확인이 필요합니다.`,
  login_korea_signup_under_14_popup_content: `(필수) 만 14세 미만 아동의 개인정보 수집 및 이용 동의`,
  login_korea_signup_under_14_guardian_popup: `만 14세 미만(이하 아동) 가입을 위해 보호자(법정대리인)의 동의와 인증이 필요합니다.`,
  login_korea_signup_under_14_guardian_popup_content_1: `(필수) 보호자(법정대리인) 개인정보 수집 및 이용동의 `,
  login_korea_signup_under_14_guardian_popup_content_2: `(필수) 아동의 개인정보 수집 및 이용동의`,
  login_korea_signup_under_14_guardian_popup_content_3: `(필수) 아동의 개인정보 제 3자 제공 동의`,
  login_korea_signup_under_14_guardian_popup_content_4: `(선택) 마케팅 활용을 위한 아동의 개인정보 제 3자 제공 동의`,
  login_korea_signup_show_link: `보기`,
  login_korea_signup_notification_popup_title: `{{year}}년 {{month}}월 {{day}}일 알림 수신을
아래와 같이 설정하였습니다.`,
  login_korea_signup_notification_popup_content_1: `이벤트 및 작품 추천 알림 수신`,
  login_korea_signup_notification_popup_content_2: `야간 혜택 알림 수신`,
  login_korea_signup_notification_popup_content_3: `기기의 앱 알림이 꺼져있으면 마케팅/야간 알림을 받을 수 없습니다.\n(기기 설정의 알림에서 변경 가능)`,
  login_korea_multiple_device_popup_title: `동시 접속 가능한 기기 수를 초과했습니다.`,
  login_korea_multiple_device_popup_content: `한 개의 아이디로 동시 접속이 가능한 기기 수는 5개 입니다. 최초 로그인한 기기에서 로그아웃하고 현재 기기에 로그인하시겠습니까?`,
  login_korea_under_14_guardian_privacy_popup: `만 14세 미만(이하 아동)의 개인정보 수집을 위해 보호자(법정대리인)의 동의와 인증이 필요합니다.`,
  merge_accounts_page_title: `카카오웹툰 로그인 유의사항`,
  merge_accounts_title: `다음ID로 다음웹툰을 즐겼다면\n카카오계정과 통합이 필요합니다.`,
  merge_accounts_question_1: `Q. 왜 계정통합을 해야하나요?`,
  merge_accounts_answer_1: `카카오웹툰은 카카오계정 로그인만 제공합니다. 다음웹툰의 사용이력과 보유캐시를 계속 유지하기 위해 계정통합이 필요합니다.
다음웹툰에서 사용하던 다음ID와 통합하지 않고 카카오계정 로그인을 하면 신규 가입되니 유의해주세요.`,
  merge_accounts_question_2: `Q. 계정통합을 하면 무엇이 좋아지나요?`,
  merge_accounts_answer_2: `기존 사용 이력과 보유 캐시를 유지하고 더 많은 무료 이용권과 선물캐시의 혜택을 받을 수 있습니다. 사용 이력과 보유캐시는 통합 완료시 자동으로 동기화되나 데이터 처리에 최대 48시간 정도 소요될 수 있습니다.`,
  merge_accounts_question_3: `Q. 이미 카카오계정을 사용하고 있다면?`,
  merge_accounts_answer_3: `별도의 통합없이 사용하던 카카오계정으로 로그인하면 됩니다. 다음웹툰의 사용이력이 유지되어 있는 것을 확인할 수 있습니다.`,
  merge_accounts_cs: `더 궁금한 점이 있다면 <link_faq>자주 묻는 질문</link_faq> 확인 또는 <link_cs>고객센터</link_cs>로 문의해주세요.`,
  merge_accounts_button: `카카오계정 통합 시작하기`,
  login_korea_notice_popup: `다음ID로 다음웹툰을 이용하셨다면
카카오웹툰 서비스를 즐기기 전
로그인 유의사항을 꼭 확인해 주세요.`,
  login_korea_notice_popup_button: `유의사항 확인`,
  luckydraw_title_slot: `행운의 슬롯머신`,
  luckydraw_title_box: `행운의 선물`,
  luckydraw_title_web: `행운의 뽑기권`,
  luckydraw_start: `시작`,
  luckydraw_win: `선물 당첨`,
  luckydraw_win_prize: `선물 당첨`,
  luckydraw_participated: `이미 참여하셨습니다.`,
  luckydraw_winning_gift: `당첨 선물`,
  luckydraw_date_received: `지급일`,
  luckydraw_expiry: `유효기간`,
  luckydraw_expiry_date: `지급일로부터 {{count}}일`,
  luckydraw_expiry_date_plural: `지급일로부터 {{count}}일`,
  luckydraw_expiry_hour: `지급일로부터 {{count}}시간`,
  luckydraw_expiry_hour_plural: `지급일로부터 {{count}}시간`,
  luckydraw_expiry_specific: `{{value}}까지`,
  luckydraw_expiry_today: `오늘`,
  luckydraw_expiry_hour_1: `지급 시간의 59분`,
  luckydraw_expired: `행운의 슬롯머신
참여 기간이 지났습니다.`,
  luckydraw_expired_box: `행운의 선물상자
참여 기간이 지났습니다.`,
  luckydraw_win_cash: `캐시 당첨`,
  luckydraw_win_cash_amount: `{{value}}캐시 당첨`,
  luckydraw_ticket_title: `작품 명`,
  luckydraw_win_ticket_amount: `선물 이용권 {{count}}장 당첨`,
  luckydraw_win_ticket_amount_plural: `선물 이용권 {{count}}장 당첨`,
  luckydraw_prize_notice: `유의사항`,
  luckydraw_prize_notice_1: `한번 제출된 정보는 수정이 불가합니다.`,
  luckydraw_prize_notice_2_kor: `카카오톡으로 전송된 기간 내 개인정보를 입력하지 않을 경우 당첨이 취소됩니다.`,
  luckydraw_prize_notice_2_specific: `개인정보를 {{date}} 안에 입력하지 않을 경우 당첨이 취소됩니다. `,
  luckydraw_prize_notice_2: `개인정보를 당첨 일로부터 {{date}} 안에 입력하지 않을 경우 당첨이 취소됩니다. `,
  luckydraw_prize_notice_3: `부정확한 정보를 입력하는 경우 당첨이 취소될 수 있습니다.`,
  luckydraw_global_enterinfo: `경품 수령 정보 입력`,
  luckydraw_global_title: `경품 수령 정보 입력`,
  luckydraw_global_enterinfo_prize: `{{prize}}를 받을 정보를 입력해 주세요.`,
  luckydraw_global_enterinfo_placeholder: `내용을 입력해주세요.`,
  luckydraw_global_enterinfo_button_submit: `제출`,
  luckydraw_global_enterinfo_button_expired: `유효기간 만료`,
  luckydraw_global_enterinfo_button_submitted: `제출 완료`,
  luckydraw_global_entered_popup: `경품 수령 정보가 입력되었습니다.`,
  luckydraw_prize_detail_korea: `경품 지급은 카카오톡 개별 메시지로 안내될 예정입니다.
메시지에서 경품 수령 관련 정보를 확인해 주세요.`,
  luckydraw_korea_participated: `이미 참여하셨습니다.
경품 지급은 카카오톡 개별 메시지로 안내될 예정입니다.`,
  luckydraw_korea_participated_date: `당첨일`,
  crm_ticker_button: `확인하기`,
  crm_bottom_event_period: `참여 기간`,
  crm_bottom_reward_title: `리워드 지급`,
  crm_bottom_notice: `유의 사항`,
  crm_comment_button: `댓글 입력하기`,
  crm_comment_count: `댓글 {{count}}개 보기`,
  crm_comment_count_plural: `댓글 {{count}}개 보기`,
  crm_advance_reservation_button: `사전 예약하기`,
  crm_advance_reservation_toast: `사전예약 신청이 완료되었습니다.`,
  crm_advance_reservation: `사전 예약`,
  crm_advance_reservation_button_v4: `신청하기`,
  crm_attendance_status_count: `{{count}}/{{max}} 출석`,
  crm_attendance_status_not_participated: `진행 전`,
  crm_attendance_status_participating: `진행 중`,
  crm_attendance_status_participated: `참여 완료`,
  crm_attendance_status_toast: `출석체크가 완료되었습니다.`,
  crm_attendance_status_day: `{{value}}회차 출석하기`,
  crm_attendance_status_day_v4: `출석 {{value}}회차`,
  crm_attendance_status_day_short: `{{value}}회차 출석`,
  crm_attendance_reward_slot_ticket: `뽑기권 지급!`,
  crm_attendance_reward_gift_ticket: `선물 이용권 지급!`,
  crm_attendance_reward_cash: `{{value}}캐시 지급!`,
  crm_attendance_button_before: `출석하기`,
  crm_attendance_button_complete: `출석완료`,
  crm_attendance_advance_register: `사전 신청하기`,
  crm_attendance_advance_register_button: `신청하기`,
  crm_attendance_advance_registered_toast: `사전 신청이 완료되었습니다.`,
  crm_attendance_advance_register_button_before: `사전 신청 하기`,
  crm_attendance_advance_register_button_after: `사전 신청 완료`,
  crm_push_mission_title: `PUSH 알림 안내`,
  crm_push_mission_content: `이벤트 소식 및 당첨 알림을 받기 위해
PUSH 알림을 켜주세요.`,
  crm_push_on_toast: `PUSH 알림 받기 설정을 완료하였습니다.`,
  crm_push_on: `PUSH 알림 켜기`,
  crm_push_on_button: `알림 켜기`,
  crm_fav_notification_popup_title: `찜한 작품에 추가되었습니다.`,
  crm_fav_notification_popup_content: `작품 업데이트 시 알림을 받게 됩니다.
알림은 '보관함 > 찜한 작품'에서 관리할 수 있습니다.`,
  crm_recommend_not_sale: `아직 판매 중인 작품이 아닙니다. 잠시 후 다시 시도해 주세요.`,
  crm_quiz_before_enter: `정답을 입력해 주세요.`,
  crm_quiz_submit_button: `정답 제출`,
  crm_quiz_submit_complete_button: `정답 제출 완료`,
  crm_quiz_correct_answer_popup: `정답입니다!
{{reward}} 지급이 완료되었습니다.`,
  crm_quiz_correct_answer_raffle_popup: `정답입니다!
응모가 완료되었습니다. `,
  crm_quiz_incorrect_answer_popup: `정답이 아닙니다.
다시 한번 도전해 보세요.`,
  crm_quiz_hint: `HINT`,
  crm_quiz_answer_exceed_toast: `작성 가능한 글자 수를 초과하였습니다.`,
  crm_share_button: `이벤트 공유하기`,
  share_invitation_code_popup: `지금 바로 초대 코드를 공유해보세요.`,
  cookie_popup_title: `쿠키 수집 안내`,
  cookie_popup_content: `카카오웹툰은 사용자들에게 맞춰 사이트를 제공하고 사이트를 보다 원활하게 이용할 수 있도록 쿠키를 사용하고 있습니다. 이 팝업을 닫으면 쿠키 수집에 동의하게 됩니다. 별도 쿠키 설정을 원하는 경우, 쿠키 설정에서 처리 가능합니다. 쿠키 수집 및 처리 방침에 대한 상세내용은 <link_privacy>개인정보처리방침</link_privacy>에서 확인할 수 있습니다.`,
  cookie_popup_button_settings: `쿠키 설정하기`,
  cookie_popup_button_accept: `모두 동의하기`,
  adid_popup_title: `맞춤형 광고 최적화 설정 안내`,
  adid_popup_content: `맞춤형 광고 최적화 활성화 시 귀하의 개인정보를 활용하여 외부 사이트에서 보다 관련성 높은 맞춤형 광고를 제공할 수 있습니다. 활성화 하시겠습니까?`,
  special_title: `스페셜`,
  mainhome_special_contenthome_button: `작품 보러 가기`,
  mainhome_popup_version_update_mandatory_title: `필수 업데이트 안내`,
  mainhome_popup_version_update_mandatory_content: `개선된 기능 및 원활한 카카오웹툰 이용을 위해 새로운 버전의 업데이트가 반드시 필요합니다. 업데이트는 대체로 1분 내외로 완료되며, 업데이트 후에 서비스를 바로 이용하실 수 있습니다.`,
  mainhome_popup_version_update_optional_title: `업데이트 안내`,
  mainhome_popup_version_update_optional_content: `최신 버전으로 업데이트 시 카카오웹툰 기능을 더욱 안정적으로 이용하실 수 있습니다. 업데이트는 대체로 1분 내외로 완료되며, 업데이트 후에 서비스를 바로 이용하실 수 있습니다.`,
  mainhome_popup_permission_title: `카카오웹툰 앱 사용 권한 안내`,
  mainhome_popup_permission_content: `앱 이용 시 다음 권한들은 필수 접근 권한으로 설정`,
  mainhome_popup_version_keep_button: `기존 버전 사용`,
  mainhome_popup_version_exit_button: `앱 종료`,
  mainhome_popup_participate_button: `참여하기`,
  mainhome_popup_dontshow_button: `다시 보지 않기`,
  mainhome_popup_view_detail_button: `자세히 보기`,
  mainhome_popup_more_button: `더 보기`,
  error_server_toast: `데이터를 불러오는데 실패했습니다.`,
  error_server_popup_request: `요청 사항을 처리하는데 실패했습니다.\n다시 시도해 주세요.`,
  mainhome_popup_idfa_ko: `'허용'을 선택하시면 불필요한 광고가 줄어들고 
관심사에 최적화된 광고만 노출됩니다. 
추적을 허용하지 않으면 랜덤으로 광고가 노출됩니다.`,
  mainhome_popup_idfa_global: `사용자 정보는 더 나은 개인화된 광고 경험을 위해 사용됩니다.`,
  mainhome_display_mode_popup_title: `이제 원하는 화면 스타일을\n선택해서 사용해 보세요.`,
  mainhome_display_mode_popup_content: `다크 모드와 라이트 모드 중\n원하는 화면 스타일을 선택할 수 있습니다.`,
  mainhome_display_mode_popup_button: `설정하러 가기`,
  badge_new: `신작`,
  badge_up: `UP`,
  badge_today: `오늘`,
  badge_new_season: `새시즌`,
  badge_ongoing: `연재`,
  badge_completed: `완결`,
  badge_hiatus: `휴재`,
  badge_completed_season: `시즌완결`,
  badge_brand: `브랜드 웹툰`,
  badge_alive: `ALIVE`,
  badge_mon: `월`,
  badge_tue: `화`,
  badge_wed: `수`,
  badge_thu: `목`,
  badge_fri: `금`,
  badge_sat: `토`,
  badge_sun: `일`,
  badge_not_available: `판매 중지`,
  badge_mon_long: `월요일`,
  badge_tue_long: `화요일`,
  badge_wed_long: `수요일`,
  badge_thu_long: `목요일`,
  badge_fri_long: `금요일`,
  badge_sat_long: `토요일`,
  badge_sun_long: `일요일`,
  badge_free: `무료`,
  badge_rent: `대여`,
  badge_possess: `소장`,
  badge_original_novel: `원작소설`,
  badge_comment_creator: `CREATOR`,
  badge_comment_best: `BEST`,
  onboarding_next_button: `다음`,
  onboarding_start_button: `시작하기`,
  onboarding_start_without_login: `로그인 없이 시작하기`,
  onboarding_start: `안녕하세요
카카오웹툰에 오신 것을 환영합니다.`,
  onboarding_skip_popup_title: `잠깐! 신규 가입자를 위한
웰컴 바우처가 기다리고 있어요.`,
  onboarding_skip_popup_content: `지금 가입하면 추천작과 함께 무료 이용권을 드려요.`,
  onboarding_skip_comfirm: `메인으로 이동`,
  onboarding_genre_title: `좋아하는 장르를 선택하면
나에게 맞는 작품을
추천받을 수 있습니다.`,
  onboarding_content_title: `축하합니다.
카카오웹툰 무료 이용권이
지급되었습니다.`,
  bridgepage_description: `카카오웹툰에서 상상력을 자극하는
웹툰들을 만나보세요.`,
  bridgepage_web_button: `웹으로 계속 보기`,
  bridgepage_app_button: `앱에서 보기`,
  bridgepage_language_change: `설정된 언어와 달라 정상 접근이 불가합니다.`,
  error_network_popup_ios: `앱 실행에 실패했습니다. 다시 시도해 주세요.`,
  offline_no_connection_popup: `네트워크에 연결되지 않았습니다.
오프라인 모드로 이용하시겠습니까?`,
  offline_no_connection_popup_exit_button: `앱 종료`,
  error_api_call_toast: `요청 사항을 처리하는데 실패했습니다.\n다시 시도해 주세요.`,
  offline_enter_button: `오프라인 모드로 진입`,
  offline_no_connection_toast: `네트워크에 연결되지 않았습니다. 네트워크 상태를 확인해 주세요.`,
  offline_convert_online_popup: `네트워크에 연결되었습니다.
온라인 모드로 전환하시겠습니까?`,
  offline_enter_online_mode: `온라인 모드`,
  offline_download_tab_title: `다운로드`,
  offline_rental_expired_toast: `대여기간이 만료되었습니다.`,
  error_region_unmatch_app_popup: `해당 국가에서 서비스를 이용할 수 없습니다.
앱 재설치 후 가입 시 선택한 국가로 접속해 주세요.`,
  error_region_unmatch_web_popup: `해당 국가에서 서비스를 이용할 수 없습니다.
가입 시 선택한 국가로 접속해 주세요.`,
  error_server_common_toast: `문제가 발생했습니다. 잠시 후 다시 시도해 주세요.`,
  error_server_duplicate_request_toast: `요청 사항을 처리 중입니다.`,
  error_version_popup_contents: `이 기능은 현재 버전에서 지원 되지 않는 기능입니다. Appstore에서 업데이트 후 이용해 주세요. `,
  error_page_not_found: `페이지를 찾을 수 없습니다.`,
  error_not_found: `요청하신 페이지를 찾을 수 없습니다.`,
  block_service_check_title: `서비스 점검 안내`,
  block_service_check_content: `더 빠르고 원활한 서비스 제공을 하기 위해 서비스 점검 작업을 진행하고자 합니다. 많은 양해 부탁드리며, 항상 좋은 서비스를 위해 최선을 다하겠습니다. 감사합니다.`,
  block_service_check_date_range: `점검 기간 {{start}} ~ {{end}}`,
  error_event_expired_popup: `이미 종료된 이벤트입니다. `,
  error_event_expired_toast: `이벤트가 종료되어 참여할 수 없습니다.`,
  error_event_participate_popup: `해당 이벤트를 참여하실 수 없습니다.`,
  error_cash_fail_aos: `결제 진행 중 Google Play에 문제가 발생했습니다. Google Play 앱의 데이터와 캐시를 모두 삭제 후 다시 시도하거나, Google Play 스토어 > 구매내역에서 대기중인 상품을 취소한 후 다시 시도해주세요.`,
  error_cash_fail_aos_button: `설정에서 삭제하기`,
  android_tampering_popup_title: `앱 위변조가 감지되어 서비스를 종료합니다.`,
  android_tampering_popup_content: `앱 삭제 및 공식 스토어를 통한 설치 후에도 동일한 현상이 발생한다면 카카오웹툰 홈페이지 고객센터로 문의 바랍니다.`,
  android_error_connection: `페이지를 로드할 수 없습니다.\n연결 상태를 확인하신 후 다시 접속해 주세요.`,
  android_error_temporary: `일시적인 오류로 페이지를 로드 할 수 없습니다.`,
  android_error_webview: `웹뷰에 문제가 발생하였습니다. 다시 실행해주세요.`,
  js_alert_leave_title: `탐색 확인`,
  leave_this_page: `이 페이지 나오기`,
  stay_this_page: `이 페이지에 머무르기`,
  question_leave_this_page: `이 페이지에서 벗어나시겠습니까?`,
  ssl_warnings_header: `사이트의 보안 인증서에 문제가 있습니다.`,
  ssl_continue: `계속`,
  security_warning: `보안 경고`,
  view_certificate: `인증서 보기`,
  ssl_go_back: `뒤로`,
  android_back_button_quit_toast: `뒤로가기 버튼을 한번 더 누르시면 종료됩니다.`,
  ssl_untrusted: `신뢰할 수 있는 인증 기관에서 발급한 인증서가 아닙니다.`,
  ssl_mismatch: `사이트 이름이 인증서에 있는 것과 일치하지 않습니다.`,
  ssl_expired: `인증서가 만료되었습니다.`,
  ssl_not_yet_valid: `인증서가 아직 유효하지 않습니다.`,
  ssl_date_invalid: `인증서 날짜가 유효하지 않습니다.`,
  ssl_invalid: `인증서가 잘못되었습니다.`,
  ssl_unknown: `알 수 없는 인증서 오류입니다.`,
  ssl_certificate: `보안 인증서`,
  ssl_certificate_is_valid: `유효한 인증서입니다.`,
  page_info: `페이지 정보`,
  page_info_view: `페이지 정보 보기`,
  page_info_address: `주소:`,
  issued_to: `발급 대상:`,
  common_name: `일반 이름:`,
  org_name: `조직:`,
  org_unit: `조직 구성 단위:`,
  issued_by: `발급 기관:`,
  validity_period: `유효성:`,
  issued_on: `발급 날짜:`,
  expires_on: `만료 날짜:`,
  serial_number: `일련번호:`,
  sha256_fingerprint: `SHA-256 지문:`,
  sha1_fingerprint: `SHA-1 지문:`,
  message_webview_certificate_transparency: `보안 인증서 문제 해결을 위해 WebView 관련 앱을 업데이트 해주세요.`,
  popup_window_attempt: `이 사이트에서 팝업 창을 열도록 허용하겠습니까?`,
  webview_allow: `허용`,
  webview_block: `차단`,
  webview_update: `업데이트`,
  webview_ok: `확인`,
  webview_cancel: `취소`,
  webview_login: `로그인`,
  js_alert_title: `'{{value}}' 페이지 내용:`,
  notification_category_download: `다운로드 알림`,
  notification_category_common: `일반 알림`,
  notification_channel_download: `에피소드 다운로드 알림을 받습니다.`,
  notification_channel_common: `회차 업데이트, 기다리면 무료, 이벤트 소식 등의 알림을 받습니다.`,
  android_battery_optimization_popup_contents: `앱을 사용하지 않을 때에도 회차를 다운로드 하려면, 배터리 최적화 대상에서 카카오웹툰 앱을 제외해야 합니다.`,
  multilingual_redeem_code_popup: `해당 언어에서 등록할 수 없는 쿠폰입니다.`,
  footer_customer_service: `고객센터`,
  footer_business_info: `사업자 정보`,
  footer_terms_of_use: `이용약관`,
  footer_privacy: `개인정보처리방침`,
  footer_inquiry: `문의하기`,
  footer_youth_protection: `청소년 보호 정책`,
  footer_business_info_confirm: `사업자 정보 확인`,
  footer_copyright: `© KAKAO WEBTOON`,
  footer_cookie_policy: `쿠키 수집 정책`,
  footer_copyright_korea: `(주) 카카오엔터테인먼트`,
  region_unsupported_title: `미지원 국가 안내`,
  region_unsupported_content: `현재 접속한 국가는 지원되지 않는 국가입니다. 서비스를 이용할 국가를 선택해 주세요. 국가를 선택하면 다른 국가로 변경은 불가합니다.`,
  region_unsupported_exit_button: `앱 종료`,
  region_country_select: `사용 국가 선택`,
  region_country_select_english: `English`,
  region_language_different_popup: `현재 국가에서 지원하는 언어로 변경이 필요하여 앱을 재실행합니다.`,
  region_restart_button: `재실행`,
  region_language_select_popup: `현재 국가에서 지원하는 언어로 변경이 필요합니다. 서비스를 이용할 언어를 선택해주세요.`,
  region_language_restart_toast: `현재 국가에서 지원하는 언어로 변경이 필요하여 앱을 재실행해 주세요.`,
  region_select_region_popup_title: `사용자 국가 선택 안내`,
  region_select_region_popup_title_v4: `사용자 언어 선택 안내`,
  region_select_region_popup_content: `서비스를 이용할 국가를 선택해주세요. 
국가를 선택하면, 다른 국가로 변경이 불가합니다.`,
  region_select_region_popup_content_v4: `서비스를 이용할 언어를 선택해주세요. 
언어 변경 시 감상 가능한 작품이 변경될 수 있습니다.`,
  region_unsupported_china_title: `서비스 이용 불가 안내`,
  region_unsupported_china_content: `저작권 문제로 인해 접속하신 지역에서는 서비스를 이용할 수 없습니다. 이용에 불편을 드려 죄송합니다.`,
  region_unsupported_china_button: `앱 종료`,
  invitation_guest_welcome_popup_title: `카카오웹툰에 초대되신 것을 환영합니다.`,
  invitation_guest_welcome_popup_content: `- 초대 선물은 이벤트 대상에게만 지급됩니다.
- 이벤트 대상에 대한 자세한 안내는 선물함 > 이벤트 페이지에서 확인할 수 있습니다.
- 나를 초대한 유저와 내 단말이 동일한 경우 초대 선물이 지급되지 않습니다.`,
  invitation_guest_welcome_popup_button: `로그인하고 초대 선물 받기`,
  invitation_guest_expired_popup_title: `이벤트 기간이 종료되었습니다.`,
  invitation_guest_login_popup: `아래 버튼을 통해 로그인 완료하시면
친구초대 리워드를 드립니다.`,
  invitation_guest_target_popup_title_new: `회원 가입을 축하합니다!`,
  invitation_guest_target_popup_title_return: `카카오웹툰에 돌아오신 것을 환영합니다!`,
  invitation_guest_target_popup_content: `- 조건이 충족된 경우 리워드가 지급될 예정입니다.
- 리워드 내역은 ‘알림 > 내소식’에서 확인하실 수 있습니다.`,
  invitation_guest_nontarget_popup_title: `이벤트 대상이 아닙니다.`,
  invitation_guest_nontarget_popup_content_return: `해당 이벤트는 카카오웹툰 신규 가입자만 참여할 수 있습니다.
카카오웹툰을 이용해주셔서 감사합니다.`,
  invitation_guest_nontarget_popup_content_new: `해당 이벤트는 일정 기간 카카오웹툰에 방문하지 않은 이용자만 참여할 수 있습니다.
카카오웹툰을 이용해주셔서 감사합니다.`,
  invitation_guest_nontarget_popup_content_active: `해당 이벤트는 카카오웹툰 신규 가입자 또는 일정 기간동안 방문하지 않은 이용자만 참여할 수 있습니다.
카카오웹툰을 이용해주셔서 감사합니다.`,
  invitation_guest_nontarget_popup_content_device: `친구를 초대한 단말과 코드를 입력하는 단말이 동일한 경우 리워드가 지급되지 않습니다. `,
  invitation_host_status_count: `{{count}}/{{max}}명 초대`,
  invitation_host_status_participating: `진행 중`,
  invitation_host_status_participated: `참여 완료`,
  invitation_host_link_share_button: `초대 링크 공유하기`,
  invitation_host_link_share_popup_title: `공유하기`,
  invitation_host_link_share_popup_content: `지금 바로 초대 코드를 공유해보세요.`,
  invitation_host_link_copied_toast: `주소가 복사 되었습니다.
원하는 곳에 붙여넣기 해주세요.`,
  invitation_host_code_share_button: `초대 코드 복사`,
  invitation_host_code_share_toast: `초대 코드: {{code}}
코드를 클립보드에 복사했습니다.`,
  universal_event_push: `{{value}} 캐시를 받았습니다.`,
  universal_event_notification_my: `스페셜 기프트 지급 완료
{{value}}를 받았습니다.`,
  universal_expiration_date: `{{value}}까지`,
  universal_event_account_popup_title: `로그인한 계정을 확인해 주세요.`,
  universal_event_account_popup_content: `선물 소식을 확인했던 서비스와 같은 계정으로 로그인해야 스페셜 기프트를 받을 수 있습니다. 로그인 계정을 확인 후 선물 내역 확인하기를 눌러주세요.`,
  universal_event_web_popup: `해당 이벤트는 앱에서 확인 가능합니다.`,
  universal_event_expired_toast: `이벤트가 종료되었습니다.`,
  universal_event_reward_failed_toast: `리워드 지급 실패
선물 내역을 다시 확인해 주세요.`,
  universal_event_error_retry_popup: `리워드 지급에 실패했습니다. 선물 받기를 다시 시도해 주세요.`,
  universal_event_error_retry_popup_button: `선물 받기`,
  universal_event_reward_failed_cs_toast: `리워드 지급 실패. 고객센터로 문의해 주세요.`,
  universal_event_reward_already_claimed_toast: `리워드가 이미 지급되었습니다.`,
  universal_event_login_popup: `선물 내역 확인을 위해 이벤트를 확인한
서비스와 같은 계정으로 로그인해 주세요.`,
};